import React, { createRef } from "react";
import ReactDOM from "react-dom";
import NESAHeader from "../Inc/NESAHeader";
import NESAFooter from "../Inc/NESAFooter";
import "./style.css";
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import warningAlert from "./warning-alert.png";
import { withRouter } from "react-router-dom";
import { history } from "../../container/History";
import InputMask from "react-input-mask";
import Iframe from "../HOC/iframe";
import moment from "moment";

import ScoutsPrimaryOrAlternateAddress from './ScoutsAddress';

import NewEagleGreetingsModal from './NewEagleGreetingsModal';

import CustomPopupModal from '../Inc/customPopupModal'
import FullPageSpinner from '../Inc/FullPageSpinner'
import { CheckCircleTwoTone } from "@ant-design/icons";
import {
    Steps,
    Button,
    Tooltip,
    Spin,
    Row,
    Col,
    Card,
    Typography,
    DatePicker,
    Modal,
    Form,
    Input,
    Radio,
    Checkbox,
    Select,
    Icon,
    Switch,
    Divider,
} from "antd";


const FormItem = Form.Item;
const Step = Steps.Step;
const InputGroup = Input.Group;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const CHASE_URL = process.env.REACT_APP_CHASE;

const GIFTED_PURCHASE = JSON.parse(process.env.REACT_APP_GIFTED_PURCHASE);

// const PENDING_MEMBERSHIP_TEXT = process.env.REACT_APP_PENDING_MEMBERSHIP_TEXT;
// const CONFIRM_MEMBERSHIP_TEXT = `On behalf of the Scouting America and the National Eagle Scout Association, I want to personally thank you for your generous gift purchasing a NESA membership for a qualified Eagle. Thank you for helping continue an Eagle's Scouting experience as a NESA member.`;
let BackBtn = false;
const { Text } = Typography;

const TroopName = (
    <Select defaultValue="Troop">
        <Option value="Troop">Troop</Option>
        <Option value="Team">Team</Option>
        <Option value="Crew">Crew</Option>
        <Option value="Post">Post</Option>
        <Option value="Post">Ship</Option>
    </Select>
);
const NESA_MID = process.env.REACT_APP_NESA_MID;
const TRANSACTION_FEE = process.env.REACT_APP_TRANSACTION_FEE;

const failedToLoadLookup_Popup_primaryConent = "We were unable to load required"
const failedToLoadLookup_secondaryConent = "Please try again."

const deceasedPopup_primaryConent = "We’re sorry, but NESA memberships cannot be issued in the name of a deceased individual."
const deceasedPopup_secondaryConent = "If you have any questions or need further assistance, please contact us at NESA@scouting.org."

class GiftMembershipForm extends React.Component {
    selectphonecountryIDRef = createRef();
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            userDetails: {},
            value: 1,
            TotalAmount: 0,
            SelectedMembership: 0,
            SelectedMembershipName: "",
            SelectedMembershipPrice: 0,
            memberSelectedKey: 0,
            RushShipping: false,
            shipping_handlingCharge: "",
            isPayTransactionFees: false,
            isDeceasedPerson: false,
            ShowPaymentSummary: true,
            transactionFee: 0,
            SelectedMembershipID: "",
            shippingAddress: 0,
            Name: "",
            firstname: "",
            middlename: "",
            lastname: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            receipt_loading: false,
            ReceiptPara1: "",
            ReceiptPara2: "",
            minutes: 0,
            seconds: 20,
            showResultModal: false,
            noIdentifyingInformation: false,
            EagleResults: [],
            selectedRecord: undefined,
            personGUID: undefined,
            NoResultsFound: false,
            ethnic: "",
            isIneligible: false,
            scouts_DOB: "",
            // phoneCountryId: "", //AAG-971 Remove 'Scout's Phone Number from NESA application process
            // PhoneNumber: "",
            scouts_DOB_MaskChar: null,
            yoursCountry: "616",
            scoutsCountry: "616",
            // ZipCodePattern : "\d{5}([ \-]\d{4})?",

            membershipRecords: {},
            PromocodeApplied: false,
            isPromoCodeEditable: true,
            DiscountAmount: 0,
            DiscountCode: "",
            createdPayments: {},
            getValidScoutState: undefined,
            getValidScoutCity: undefined,
            isShow_MissingFieldsPopup: false,
            getAmount: 0,
            existingLifePlan: false,
            doesShowNewMemberGreetings: false,
            isApplicableForNewEagle: false,
            isShippingAddress: true, //For Gift membership we don't allow the user to update home address while purchasing
            lookupsLoaded: false,
            showLookupError: false,
            pageLoader: true,
            failedLookups: []
        };

        this.selectMembership = this.selectMembership.bind(this);
        this.ethnicities = this.ethnicities.bind(this);
        this.SelectEagle = this.SelectEagle.bind(this);
        window.showGiftReceiptComponent = this;
    }

    showLoadingReceipt = () => {
        this.setState({
            receipt_loading: true,
        });
        this.loadingInterval = setInterval(() => {
            const { seconds, minutes } = this.state;

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1,
                }));
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.loadingInterval);
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59,
                    }));
                }
            }
        }, 1000);
    };

    getValidScoutCityStateHandler = (state, city) => {
        let getValidScoutState, getValidScoutCity;
        let getstate = this.props.allstates.filter((stateItem) => {
            return stateItem.short == state;
        });
        if (getstate.length == 0) {
            getValidScoutState = null;
            getValidScoutCity = null;
        } else {
            getValidScoutState = state;
            getValidScoutCity = city;
        }

        return { getValidScoutState, getValidScoutCity };
    };

    RushShipping = (e) => {
        if (e.target.checked) {
            this.setState({
                RushShipping: true,
                TotalAmount: parseInt(this.state.TotalAmount) + 40,
            });
            this.props.actions.GiftMembership(
                this.state.SelectedMembershipID,
                this.state.userDetails,
                true,
                this.state.TotalAmount + 40,
                "GIFT NESA",
                NESA_MID
            );
        } else {
            this.setState({
                RushShipping: false,
                TotalAmount: parseInt(this.state.TotalAmount) - 40,
            });
            this.props.actions.GiftMembership(
                this.state.SelectedMembershipID,
                this.state.userDetails,
                false,
                this.state.TotalAmount - 40,
                "GIFT NESA",
                NESA_MID
            );
        }
    };

    // countries = () => {
    //     if (this.props.countries) {
    //         let countriesarray = this.props.countries.sort((a, b) => a.name - b.name);
    //         return countriesarray.map((k, index) => {
    //             return (
    //                 <option key={index} value={k.id}>
    //                     {k.name}
    //                 </option>
    //             );
    //         });
    //     }
    // };

    countries = () => {
        if (this.props.countries) {
            const countriesarray = [...this.props.countries].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return countriesarray.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.name}
                </Option>
            ));
        }

        return null;
    };

    showReceipt = (RegID, response) => {
        setTimeout(
            function () {
                // this.props.actions.changeMembershipStatusToProcessed(RegID, this.state.memberId, false);
                this.props.actions.getRegStatusandSendReceipt(
                    RegID,
                    this.state.userDetails,
                    "GIFT-NESA",
                    this.state.email,
                    response,
                    false,
                    this.state.memberId
                );
            }.bind(this),
            15000
        );
    };

    renderReceiptpage = () => {
        if (this.props.regstatus) {
            // if (this.props.regstatus[0].applicationStatusId == "4") {
            //     this.setState({
            //         ReceiptPara1: PENDING_MEMBERSHIP_TEXT,
            //     });
            // }
            // if (this.props.regstatus[0].applicationStatusId == "21") {
            //     this.setState({
            //         ReceiptPara1: CONFIRM_MEMBERSHIP_TEXT,
            //     });
            // }
            this.setState({
                current: 5,
            });
        }
    };

    // checkApplicableForNewEagle = (eagleBOR) => {
    //     const currentDate = new Date();//AAG-1240 -  A NEW EAGLE STATUS IS NOW EXTENDED FOR A YEAR FROM THE BOR DATE.
    //     const newEagleApplicablePeriod = moment(eagleBOR).add(1, 'Year').subtract(1, 'day').format('MM/DD/YYYY');

    //     return Boolean(moment(currentDate).isSameOrAfter(eagleBOR) && moment(currentDate).isSameOrBefore(newEagleApplicablePeriod));

    // }

    checkApplicableForNewEagle = (eagleBOR) => {
        if (!eagleBOR) return false;
            
        const bor = moment(eagleBOR).startOf('day');
        const today = moment().startOf('day');
        const oneYearAgo = moment().subtract(1, 'year').startOf('day');
            
        return bor.isBetween(oneYearAgo, today, undefined, '[]');
    }

    closeNewMemberGreetingsModal = () => {
        this.setState({
            doesShowNewMemberGreetings: false,
        })
        // history.push('/')
    }

    closeDeceasedPersonPopup = () => {
        this.setState({isDeceasedPerson: false})
}

    selectMembership = (id, name, amt, SH_Fee) => {
        let transactionFee = ((amt + SH_Fee) * TRANSACTION_FEE) / 100;
        transactionFee = (Math.round(transactionFee * 100) / 100).toFixed(2);
        let total = (Math.round((amt + SH_Fee) * 100) / 100).toFixed(2);

        this.setState({
            SelectedMembershipID: id,
            SelectedMembershipName: name,
            SelectedMembershipPrice: (Math.round(amt * 100) / 100).toFixed(2),
            shipping_handlingCharge: (Math.round(SH_Fee * 100) / 100).toFixed(2),
            transactionFee: transactionFee,
            TotalAmount: total,
        });
        const current = this.state.current + 1;
        this.setState({ current });
        //this.props.actions.getEthnicities();
    };

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    prev() {
        BackBtn = true;
        const current = this.state.current - 1;
        let length = this.state.EagleResults.length;
        if (current == 1 && length > 1) {
            this.setState({
                current,
                showResultModal: true,
            });
        } else if (current == 1 && length == 1) {
            this.setState({
                current,
                // NoResultsMatchProfile: true
            });
        } else if (current == 2) {
            this.props.form.setFieldsValue({
                promocode: "",
            });
            let transactionFee = (
                ((parseFloat(this.state.SelectedMembershipPrice) +
                    parseFloat(this.state.shipping_handlingCharge)) *
                    TRANSACTION_FEE) /
                100
            ).toFixed(2);
            let TotalAmount = (
                parseFloat(this.state.SelectedMembershipPrice) +
                parseFloat(this.state.shipping_handlingCharge) +
                (this.state.isPayTransactionFees ? parseFloat(transactionFee) : 0)
            ).toFixed(2);

            this.setState({
                current,
                // transactionFee,
                TotalAmount: TotalAmount,
                isPromocodeRemoved: true,
                PromocodeError: false,
                PromocodeApplied: false,
                isPromoCodeEditable: true,
                DiscountAmount: 0,
                DiscountCode: "",

                // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
            });
        } else if (current == 3 || current == 4) {
            // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
            // let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
            this.setState({
                current,
                // DiscountAmount: 0,
                // TotalAmount: total,
                // transactionFee,
                // PromocodeApplied: false,
                // PromocodeError: false,
                // isPayTransactionFees: false,
            });
        } else {
            this.setState({ current });
        }
        //this.props.actions.getEthnicities();
    }

    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates;
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.short}>
                        {k.short}
                    </option>
                );
            });
        }
    };

    statesID = () => {
        if (this.props.allstates) {
            return this.props.allstates.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.short}
                </Option>
            ));
        }

        return null;
    };

    promoButtons = () => {
        if (this.state.PromocodeApplied && this.state.isPromoCodeEditable) {
            return (
                <Input
                    disabled
                    autoComplete="off"
                    addonAfter={
                        <Button
                            style={{
                                backgroundColor: "#e60b2f",
                                color: "#fff",
                                borderColor: "transparent",
                            }}
                            loading={this.state.applingPromocode}
                            onClick={() => this.handlePromoRemove()}
                            icon="close"
                        >
                            {this.state.removingPromocode ? "Removing" : "Remove"}
                        </Button>
                    }
                    size="small"
                    className="promocodeInput"
                    placeholder="Code"
                />
            );
        } else if (this.state.isPromoCodeEditable) {
            return (
                <Input
                    autoComplete="off"
                    addonAfter={
                        <Button
                            type="primary"
                            loading={this.state.applingPromocode}
                            htmlType="submit"
                            icon="check"
                        >
                            Apply
                        </Button>
                    }
                    size="small"
                    className="promocodeInput"
                    placeholder="Code"
                />
            );
        } else if (!this.state.isPromoCodeEditable) {
            return (
                <Input
                    disabled
                    autoComplete="off"
                    addonAfter={
                        <Button type="default" className="successBtn" icon="check-circle">
                            applied
                        </Button>
                    }
                    size="small"
                    className="promocodeInput"
                    placeholder="Code"
                />
            );
        }
    };

    backtoStep1 = () => {
        const current = this.state.current == 2;
        this.setState({
            current,
        });
    };
    calculateFee = () => {
        // let transactionFee =
        //     ((parseFloat(this.state.SelectedMembershipPrice) +
        //         parseFloat(this.state.shipping_handlingCharge)) *
        //         TRANSACTION_FEE) /
        //     100;
        // let totalPrice = this.state.isPayTransactionFees
        //     ? parseFloat(this.state.TotalAmount) - transactionFee
        //     : parseFloat(this.state.TotalAmount) + transactionFee;
        // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
        this.setState({
            isPayTransactionFees: !this.state.isPayTransactionFees,
            // TotalAmount: totalPrice,
        });
    };

    InitTrans = () => {
        this.props.actions.InitOrbitalPayments(
            this.state.TotalAmount,
            "GIFT NESA",
            NESA_MID,
            this.state.membershipRecords,
            this.state.userDetails.g_email,
            // this.state.PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application process
            this.state.createdPayments,
            this.state.isShippingAddress
        );
        if (this.state.PromocodeApplied) {
            this.setState({
                isPromoCodeEditable: false,
            });
        }
    };

    handlePaymentSummary = () => {
        let values = this.state.userDetails;
        //shipping email address
        values.email = values.shipping == 1 ? values.g_email : values.email;

        // })
        // let person_ethnic = values.ethnic
        // let ethnicitiesArray = this.props.ethnicities
        // let ethnic = undefined;

        // // this.setState({
        // //     profilevalues: values
        // // })
        // ethnicitiesArray.map((k, index) => {
        //     if (k.short == person_ethnic) {
        //         values.ethnic = k.id
        //         if (this.state.ethnic == '') {
        //             ethnic = k.short
        //             // this.setState({
        //             //     ethnic: k.short
        //             // })
        //         }
        //     } else if (k.name == person_ethnic) {
        //         values.ethnic = k.id
        //         if (this.state.ethnic == '') {
        //             ethnic = k.short
        //             // this.setState({
        //             //     ethnic: k.short
        //             // })
        //         }
        //     }
        //     else {
        //         console.log('no ethnic found')
        //     }
        // })

        // let eagleScoutState = values.scout_state;

        // if (eagleScoutState && this.props.allstates) {
        //     let statesarray = this.props.allstates
        //     statesarray.map((k, index) => {
        //         if (k.id === eagleScoutState) {
        //             values.scout_state = k.short
        //         }
        //     })
        // }

        //adding membership type
        values.MembershipType = this.state.SelectedMembershipID;

        values.state = this.state.getValidScoutState;
        values.city = this.state.getValidScoutCity;

        let selectedRecord = { ...this.state.selectedRecord };
        selectedRecord.dob = this.state.scouts_DOB;
        let userDetails = values
        userDetails.zipcode = this.state.selectedRecord.zipCode
        this.setState({
            firstname: values.firstname,
            middlename: values.middlename,
            lastname: values.lastname,
            address1: selectedRecord.address1,
            address2: selectedRecord.address2 ? selectedRecord.address2 : "",
            city: selectedRecord.city,
            zip: selectedRecord.zipCode,
            userDetails,
            selectedRecord,
        });
        //Troop Number added upto 4 digits
        let TroopNumber = values.troopnumber;
        while (TroopNumber.length < 4) TroopNumber = "0" + TroopNumber;
        values.troopnumber = TroopNumber;

        //Transaction fee added
        values.isPayTransactionFees = this.state.isPayTransactionFees;
        values.transactionFee = this.state.transactionFee;
        values.isUpdatePrimaryAddress = !this.state.isShippingAddress;
        // selectedRecord.phoneCountryId = this.state.phoneCountryId ? this.state.phoneCountryId : "636"
        this.props.actions.GiftMembership(
            this.state.SelectedMembershipID,
            values,
            false,
            parseFloat(this.state.TotalAmount),
            "GIFT NESA",
            NESA_MID,
            selectedRecord,
            null,
            "GIFT-NESA", this.state.isApplicableForNewEagle
        );
        BackBtn = false;
        this.setState({
            ShowPaymentSummary: false,
        });
    };

    handlePromoSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.ApplyPromocode(this.state.membershipRecords, values, "GIFT-NESA");
                this.setState({
                    DiscountCode: values.promocode,
                });
            }
        });
    };
    handlePromoRemove = () => {
        // e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.RemovePromocode(
                    this.state.membershipRecords,
                    values,
                    'GIFT-NESA'
                );
                // this.setState({
                //     DiscountCode: values.promocode
                // })
            }
        });
    };

    newEagleDiscountMsg = () => {
        const { shoppingCartList } = this.props;
        if (shoppingCartList) {
            const isPromoCodeAdded = shoppingCartList.shoppingCart.some(cartList =>
                cartList.feeStructureCode === "NESA5NE-5Year" || cartList.feeStructureCode === "NESANE-LT"
            );
            if (isPromoCodeAdded) {
                return (
                    <div style={{ display: 'inline' }}>
                        <span className='Promocode-Added'>&#40;with New Eagle Discount&#41;</span>
                    </div>
                );
            }
        }
        return null;
    }

    renderPaymentSummary = () => {
        const { getFieldDecorator } = this.props.form;
        const { nesa_reg, nesa_levels } = this.props;
        return (
            <div
                className="payment-summary centered"
                style={{ marginBottom: "40px" }}
            >
                <Form className="search-form alumni-ui">
                    <Row type="flex" justify="center" align="center">
                        <Col className="card-margin" span={24}>
                            <Card className="centered" title="SUMMARY">
                                <div style={{ padding: "10px 30px" }} className="upgrade-frame-card-padd">
                                    <Row>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="Summary-title-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                Eagle Info
                                            </div>
                                        </Col>
                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="right"
                                        >
                                            <div className="verified">
                                                <Icon type="check-circle" /> Verified
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="summary-label-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {this.state.firstname} {this.state.middlename} {this.state.lastname}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="summary-label-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {this.state.memberId}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Divider style={{ margin: "10px 0px" }} />

                                    <Row>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="Summary-title-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                LEVEL
                                            </div>
                                        </Col>
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <div className="verified"><Icon type="check-circle" /> {this.state.SelectedMembershipName}</div>
                            </Col> */}
                                    </Row>
                                    <Row>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="summary-label-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {this.state.SelectedMembershipName} {this.newEagleDiscountMsg()}
                                            </div>
                                        </Col>

                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="right"
                                        >
                                            <div className="summary-label-txt">
                                                ${this.state.SelectedMembershipPrice}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Divider style={{ margin: "10px 0px" }} />

                                    
                                            <Form onSubmit={this.handlePromoSubmit}>
                                                <div className="promotions">
                                                    <Row type="flex" align="middle">
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div className="summary-label-txt">
                                                                Promotion code
                                                            </div>
                                                        </Col>
                                                        <Col
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={12}
                                                            xl={12}
                                                            className="right"
                                                        >
                                                            {getFieldDecorator("promocode", {
                                                                initialValue: this.state.DiscountCode
                                                                    ? this.state.DiscountCode
                                                                    : "",
                                                                rules: [{ required: false }],
                                                            })(this.promoButtons())}
                                                        </Col>
                                                    </Row>
                                                    <Row type="flex" align="middle" justify="end">
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            {this.state.PromocodeError &&
                                                                !this.state.PromocodeApplied && (
                                                                    <Text type="danger">
                                                                        <Icon type="info-circle" />
                                                                        {this.props.PromocodeError
                                                                            ? this.props.PromocodeError.errorDesc
                                                                                ? this.props.PromocodeError.errorDesc
                                                                                : this.props.PromocodeError
                                                                            : "Invalid Promo Code!"}
                                                                    </Text>
                                                                )}
                                                            {this.state.PromocodeApplied && (
                                                                <Text type="success">
                                                                    <Icon type="check-circle" /> Promo Code added
                                                                    successfully!
                                                                </Text>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    {this.state.DiscountAmount != 0 && (
                                                        <Row>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div
                                                                    className="summary-label-txt"
                                                                    style={{ fontSize: "14px" }}
                                                                >
                                                                    Discount Amount
                                                                </div>
                                                            </Col>
                                                            <Col
                                                                xs={24}
                                                                sm={24}
                                                                md={12}
                                                                lg={12}
                                                                xl={12}
                                                                className="right"
                                                            >
                                                                <div className="summary-label-txt green-txt">

                                                                    -$ {this.state.DiscountAmount}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </div>
                                                {this.state.PromocodeApplied && (
                                                    <Row>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div
                                                                className="summary-label-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                Membership Cost
                                                            </div>
                                                        </Col>

                                                        <Col
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={12}
                                                            xl={12}
                                                            className="right"
                                                        >
                                                            <div className="summary-label-txt">
                                                                $
                                                                {parseFloat(
                                                                    parseFloat(this.state.SelectedMembershipPrice) -
                                                                    parseFloat(this.state.DiscountAmount)
                                                                ).toFixed(2)}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Form>
                                            <Divider style={{ margin: "10px 0px" }} />
                                        
                                    
                                    <Row>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="summary-label-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                {this.state.SelectedMembershipName} Shipping/Handling
                                            </div>
                                        </Col>

                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="right"
                                        >
                                            <div className="summary-label-txt">
                                                ${this.state.shipping_handlingCharge}
                                            </div>
                                        </Col>
                                    </Row>
                                    {this.state.isPayTransactionFees && (
                                        <Row>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div
                                                    className="summary-label-txt"
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    Transaction Fee
                                                </div>
                                            </Col>

                                            <Col
                                                xs={24}
                                                sm={24}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                                className="right"
                                            >
                                                <div className="summary-label-txt">
                                                    ${this.state.transactionFee}
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    <Divider style={{ margin: "10px 0px" }} />
                                    <Row style={{ display: "flex", alignItems: "center" }} className='total-charge'>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div
                                                className="summary-label-txt"
                                                style={{ fontSize: "14px" }}
                                            >
                                                TOTAL CHARGE
                                            </div>
                                            {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                        </Col>

                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="right"
                                        >
                                            <div className="summary-price">
                                                $ {this.state.TotalAmount}
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* 
                            <Row >
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div className="summary-label-txt" style={{ fontSize: '14px' }} >{this.state.firstname} {this.state.middlename} {this.state.lastname}</div>
                                </Col>
                            </Row> */}
                                    {/* <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                                    {this.renderSearchButton()}
                                </Col>
                            </Row> */}
                                </div>
                            </Card>
                        </Col>
                    </Row>

                    <div className="steps-action centered" style={{ width: "100%" }}>
                        <Row style={{ position: "unset" }}>
                            <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                                <div
                                    className="text-result pointer"
                                    style={{ marginTop: "55px", marginBottom: "55px" }}
                                    onClick={() => {
                                        // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                        // this.setState({
                                        //     current: 0,
                                        //     ShowPaymentSummary: true,
                                        //     isPayTransactionFees: false,
                                        //     TotalAmount: total
                                        // })
                                        // history.push('/purchase-membership')
                                        this.prev();
                                    }}
                                >
                                    <i className="fa fa-lg fa-long-arrow-left margin-right-5"></i>
                                    Back to Eagle Info
                                </div>
                            </Col>
                            {/* <Col className='xs-center sm-center ' xs={24} sm={24} md={14} lg={14} xl={14} offset={2}>
                                                        <FormItem>
                                                            <Button type="primary" style={{ width: '100%' }} className='back-btn' onClick={() => this.prev()}>This is not me</Button>
                                                        </FormItem>
                                                    </Col> */}
                            <Col
                                className="xs-center sm-center"
                                xs={24}
                                sm={24}
                                md={8}
                                lg={8}
                                xl={8}
                                offset={1}
                            >
                                {this.renderPayNowButton()}
                            </Col>
                        </Row>
                    </div>
                </Form>
            </div>
        );
    };

    renderIframe = () => {
        if (this.props.initloading == true) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Chase Payments..."
                        />
                    </Col>
                </Row>
            );
        } else if (this.props.registration_loading) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Please Wait..."
                        />
                    </Col>
                </Row>
            );
        } else if (this.props.initTransaction) {
            return (
                <Row className="chase-payment">
                    <Col span={24}>
                        <Iframe
                            src={`${CHASE_URL}` + this.props.initTransaction.uID}
                            height="700px"
                            width="100%"
                        />
                    </Col>
                </Row>
            );
        } else {
            return (
                <Row>
                    <Col span={24} className="centered margin-top-30">
                        <div className="margin-bottom-20">Unable to load the payment form. Please try again.</div>
                        <Button type="primary" onClick={() => this.InitTrans()}>Try Again</Button>
                    </Col>
                </Row>
            );
        }
    };

    closeMissingFieldsPopup = () => {
        this.setState({
            isShow_MissingFieldsPopup: false
        })
    }

    ProceedTo_Membership_Workflow = (email) => {
        this.props.actions.GiftMembership(
            this.state.SelectedMembershipID,
            this.state.userDetails,
            false,
            parseFloat(this.state.getAmount),
            "GIFT NESA",
            NESA_MID,
            this.state.selectedRecord,
            email,
            "GIFT-NESA", this.state.isApplicableForNewEagle
        );
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                values.state = this.state.getValidScoutState;
                values.city = this.state.getValidScoutCity;

                let selectedRecord = { ...this.state.selectedRecord };
                selectedRecord.dob = this.state.scouts_DOB;

                let statesarray = this.props.allstates;
                statesarray.map((k, index) => {
                    // if (k.id == values.scout_state) values.stateName = k.short;
                    if (k.id == selectedRecord.stateId) {
                        values.stateName = k.short;
                    };
                });
                //adding membershiptype
                values.MembershipType = this.state.SelectedMembershipID;

                //Adding address
                values.addressline1 = selectedRecord.address1 ? selectedRecord.address1 : '';
                values.addressline2 = selectedRecord.address2 ? selectedRecord.address2 : '';

                //Troop Number added upto 4 digits
                let TroopNumber = values.troopnumber;
                while (TroopNumber.length < 4) TroopNumber = "0" + TroopNumber;
                values.troopnumber = TroopNumber;

                //Transaction fee added
                values.isPayTransactionFees = this.state.isPayTransactionFees;
                values.transactionFee = this.state.transactionFee;
                values.isUpdatePrimaryAddress = !this.state.isShippingAddress;
                // selectedRecord.phoneCountryId = this.state.phoneCountryId ? this.state.phoneCountryId : "636"
                let amount = (
                    parseFloat(this.state.SelectedMembershipPrice) +
                    parseFloat(this.state.shipping_handlingCharge) +
                    (this.state.isPayTransactionFees
                        ? parseFloat(this.state.transactionFee)
                        : 0)
                ).toFixed(2);

                // Adding Purchaser's email if it's not passed
                if (!values.email) {
                    values.email = this.state.selectedRecord.email;
                }

                let userDetails = values
                userDetails.zipcode = this.state.selectedRecord.zipCode

                // BackBtn = false;
                this.setState({
                    memberId: selectedRecord.memberId,
                    firstname: selectedRecord.firstName,
                    middlename: selectedRecord.middleName,
                    lastname: selectedRecord.lastName,
                    address1: values.ScoutsAddressline1 ? values.ScoutsAddressline1 : undefined,
                    address2: values.ScoutsAddressline2 ? values.ScoutsAddressline2 : undefined,
                    address3: values.ScoutsAddressline3 ? values.ScoutsAddressline3 : undefined,
                    city: values.city ? values.city : undefined,
                    zip: values.zipCode ? values.zipCode : undefined,
                    selectedRecord,
                    ShowPaymentSummary: false,
                    userDetails,
                    getAmount: amount
                }, () => {
                    if (this.state.selectedRecord.email === "") {
                        this.setState({
                            isShow_MissingFieldsPopup: true,
                        });
                    } else {
                        this.ProceedTo_Membership_Workflow(this.state.selectedRecord.email);
                    }
                });
            }
        });
    };

    handleSubmit_MissingField = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let selectedRecord = { ...this.state.selectedRecord };
                selectedRecord.email = values.email;
                let userDetails = { ...this.state.userDetails };
                userDetails.email = values.email;

                this.setState({
                    selectedRecord,
                    userDetails,
                    isShow_MissingFieldsPopup: false
                })

                this.ProceedTo_Membership_Workflow(values.email);
            }
        });
    };
    
    ethnicities = () => {
        if (this.props.ethnicities) {
            let ethnicitiesArray = this.props.ethnicities;
            return ethnicitiesArray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>
                        {k.name}
                    </option>
                );
            });
        }
    };

    getPhoneCode = () => {
        if (this.props.phonecode) {
            const phonecode = [...this.props.phonecode].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return phonecode.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.name}
                </Option>
            ));
        }

        return null;
    };

    renderPayNowButton = () => {
        if (this.props.initloading) {
            return (
                <FormItem>

                    <Button type="primary" className="submit-btn" id="goToCart-btn" loading>

                        Loading ...
                    </Button>
                </FormItem>
            );
        } else {
            return (
                <FormItem>
                    <Button
                        type="primary"
                        style={{ width: "100%" }}
                        className="submit-btn gift-paynow"
                        id="goToCart-btn"
                        onClick={() => this.InitTrans()}
                    >

                        Pay Now
                    </Button>
                </FormItem>
            );
        }
    };

    renderPaymentButton = () => {
        if (this.props.response && this.props.createdPayments && !BackBtn) {
            this.next();
        }
        if (this.props.loading || this.props.creatingPayments) {
            return (
                <FormItem>

                    <Button type="primary" className="submit-btn" id="goToCart-btn" loading>

                        Loading ...
                    </Button>
                </FormItem>
            );
        } else {
            return (
                <FormItem>
                    <Button type="primary" className="submit-btn" id="goToCart-btn" htmlType="submit">
                        NEXT
                    </Button>
                </FormItem>
            );
        }
    };

    componentDidMount = () => {
        this.props.actions.getProductPrice()
        this.props.actions.getNESAmembershiplevels()
        this.props.actions.getEthnicities()
        this.props.actions.getStates()
        this.props.actions.getCountries()
        this.props.actions.getPhoneCountries()
    };

    componentDidUpdate(prevProps) {
  if (
    !prevProps.regError &&
    this.props.regError &&
    this.state.receipt_loading
  ) {
    this.setState({ receipt_loading: false });

    const { errorCode, message, errorDesc } = this.props.regError;

    Modal.error({
      title: `Error ${errorCode || ""}`,
      content: (
        <div>
          <p><b>{message || "Request failed"}</b></p>
          {errorDesc && <p>{errorDesc}</p>}
        </div>
      )
    });
  }
}


    renderLevels = () => {
        if (this.props.productprice_loading) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading NESA levels..."
                        />
                    </Col>
                </Row>
            );
        }
        if (this.props.nesa_levels && this.props.productprice) {
            let nesalevels = this.props.nesa_levels;
            let productprice = this.props.productprice;

            return nesalevels.map((k, index) => {
                let price = 0;
                let shipping_handlingCharge = 0;
                let shipping_StructureCode;
                let productname = k.name.replace(/-/g, " ");
                productprice.map((j, index) => {
                    if (k.name == j.feeStructureCode) {
                        price = (Math.round(j.termFee * 100) / 100).toFixed(2);
                        if (k.name.includes("5Year")) {
                            //if (k.name == "NESA-Silver-5Year") {
                            shipping_StructureCode = "NESA5SH";
                        } else if (k.name.includes("Lifetime")) {
                            //  } else if (k.name == "NESA-Gold-Lifetime") {
                            shipping_StructureCode = "NESALIFESH";
                        }
                    }
                });

                productprice.map((j, index) => {
                    if (shipping_StructureCode == j.feeStructureCode) {
                        shipping_handlingCharge = (
                            Math.round(j.termFee * 100) / 100
                        ).toFixed(2);
                    }
                });

                return (
                    <Col xs={24} sm={24} md={12} lg={12} className="welcome-nesa-padding">
                        <div className="membership-card">
                            <img src="../NESA.png" className="NESA-logo" />
                            <span className="membership-level">{productname == 'NESA 5Year' ? 'NESA 5-year' : productname}</span>
                            <span className="membership-price">${price}</span>
                            <Button
                                className="membership-start pointer"
                                onClick={() =>
                                    this.selectMembership(
                                        k.id,
                                        productname,
                                        Number(price),
                                        Number(shipping_handlingCharge)
                                    )
                                }
                            >
                                START
                            </Button>
                        </div>
                    </Col>
                );
            });
        }
    };

    format_Date = (e, field) => {
        let val = e.target.value.split("/");
        let NumExp = /[0-9]/;
        val[0] = NumExp.test(val[0])
            ? val[0].startsWith("-")
                ? val[0].replace("-", "0")
                : val[0]
            : "";
        val[1] = NumExp.test(val[1])
            ? val[1].startsWith("-")
                ? val[1].replace("-", "0")
                : val[1]
            : "";
        val = val.toString().replaceAll(",", "/");

        // console.log("val final " + val);
        // let g = this.props.form.getFieldValue('scout_dob');
        // console.log("getFieldValue " + g);
        if (field == "scout_dob") {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    scout_dob: val,
                });
            }, 0);
            this.setState({
                scouts_DOB: val,
            });
        } else if (field == "DOB") {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    dob: val,
                });
            }, 0);
            this.setState({
                scouts_DOB: val,
            });
        }
        // else if (field == "C_DATE") {
        //     setTimeout(() => {
        //         this.props.form.setFieldsValue({
        //             certificate_date: val,
        //         });
        //     }, 0)
        // }
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                values.scout_dob = this.state.scouts_DOB;
                this.props.actions.searchEagle(values);
                // this.setState({
                //     scouts_DOB: values.scout_dob
                // })
            }
        });
    };

    renderSearchButton = () => {
        if (this.props.response && !BackBtn) {
            this.next();
        }
        // if (this.props.loading) {
        //     return <FormItem> <Button type="primary" className='submit-btn' loading > Loading ...</Button></FormItem>
        // } else {
        return (
            <FormItem>

                <Button type="primary" className="submit-btn" id="goToCart-btn" htmlType="submit">
                    {this.props.searching ? "Searching..." : "SEARCH"}
                </Button>
            </FormItem>
        );
        // }
    };

    componentWillReceiveProps = (nextprops) => {
        if (nextprops.ethnicitiesError || nextprops.productpriceError || nextprops.nesa_levelsError || nextprops.allstatesError || nextprops.countriesError || nextprops.phonecodeError){
            const failedLookups = [];
            if (nextprops.ethnicitiesError) failedLookups.push("Ethnicities")
            if (nextprops.productpriceError) failedLookups.push("Product Price")
            if (nextprops.nesa_levelsError) failedLookups.push("Nesa Levels")
            if (nextprops.allstatesError) failedLookups.push("States")
            if (nextprops.countriesError) failedLookups.push('Countries')
            if (nextprops.phonecodeError) failedLookups.push('Phonecode')
            this.setState({ showLookupError: true, pageLoader: false, failedLookups });
        }

        if (nextprops.allstates && nextprops.allstates.length > 0 &&
            nextprops.ethnicities && nextprops.ethnicities.length > 0 &&
            nextprops.countries && nextprops.countries.length > 0 &&
            nextprops.phonecode && nextprops.phonecode.length > 0 &&
            nextprops.productprice && nextprops.productprice.length > 0 &&
            nextprops.nesa_levels && nextprops.nesa_levels.length > 0) 
            {
            this.setState({ lookupsLoaded: true, showLookupError: false, pageLoader: false });
        }

        if (this.props.applingPromocode !== nextprops.applingPromocode) {
            if (nextprops.applingPromocode) {
                this.setState({
                    applingPromocode: true,
                });
            }
            if (!nextprops.applingPromocode) {
                this.setState({
                    applingPromocode: false,
                });
            }
        }
        if (this.props.PromocodeAdded !== nextprops.PromocodeAdded) {
            if (nextprops.PromocodeAdded) {
                // let TotalAmount = this.state.TotalAmount;
                // let DiscountAmount = (nextprops.PromocodeAdded).toFixed(2);
                // let membershipCost = parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(DiscountAmount)).toFixed(2)

                // let transactionFee = (((parseFloat(membershipCost) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let totalPrice = this.state.isPayTransactionFees ? (
                //     (parseFloat(TotalAmount) - parseFloat(DiscountAmount) - parseFloat(this.state.transactionFee)) + parseFloat(transactionFee) 
                // ) 
                // : (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
                this.setState({
                    // transactionFee,
                    // TotalAmount: totalPrice,
                    PromocodeApplied: true,
                    isPromoCodeEditable: true,
                    PromocodeError: false,
                    // DiscountAmount: DiscountAmount,
                    // DiscountCode: nextprops.promoCode
                    // // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                })
            }
        }
        if (this.props.shoppingCartList !== nextprops.shoppingCartList && nextprops.shoppingCartList) {
            let transactionFee = 0;
            let shipping_handlingCharge = 0;
            let remainingMembershipAmount = 0;
            let SelectedMembershipPrice = 0;
            let DiscountAmount = 0;
            let DiscountCode = '';
            nextprops.shoppingCartList.shoppingCart.map(cartList => {
                if (cartList.feeStructureCode === "OLRADMIN") {
                    return transactionFee = parseFloat(cartList.amount).toFixed(2)
                }
                // if(cartList.feeStructureCode === "NESALIFECREDIT" ) {
                //     return remainingMembershipAmount = parseFloat(cartList.amount)
                // }
                if (cartList.feeStructureCode === 'NESA-5Year' || cartList.feeStructureCode === 'NESA-Lifetime' || cartList.feeStructureCode === "NESALIFECREDIT" || cartList.feeStructureCode === "NESA5NE-5Year" || cartList.feeStructureCode === "NESANE-LT") {
                    return SelectedMembershipPrice = parseFloat(cartList.amount).toFixed(2)
                }
                if (cartList.product.includes('Shipping/Handling')) {
                    return shipping_handlingCharge = parseFloat(cartList.amount).toFixed(2)
                }
                if (cartList.feeStructureCode.includes('PROMO')) {
                    DiscountCode = cartList.promoCode
                    return DiscountAmount = parseFloat(cartList.amount).toFixed(2)

                }
            })

            this.setState({
                transactionFee,
                remainingMembershipAmount,
                shipping_handlingCharge,
                SelectedMembershipPrice,
                DiscountAmount,
                DiscountCode,
                TotalAmount: nextprops.shoppingCartList.totalAmountDue
            })
        }
        if (this.props.PromocodeRemoved !== nextprops.PromocodeRemoved) {
            if (nextprops.PromocodeRemoved) {
                this.props.form.setFieldsValue({
                    promocode: '',
                });
                // let transactionFee = (((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let TotalAmount = (parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge) + (this.state.isPayTransactionFees ? parseFloat(transactionFee) : 0)).toFixed(2)

                // let TotalAmount = this.state.TotalAmount;
                // let DiscountAmount = (nextprops.PromocodeAdded).toFixed(2);
                // let membershipCost = parseFloat(parseFloat(this.state.SelectedMembershipPrice) - parseFloat(DiscountAmount)).toFixed(2)

                // let transactionFee = (((parseFloat(membershipCost) + parseFloat(this.state.shipping_handlingCharge)) * TRANSACTION_FEE) / 100).toFixed(2)
                // let totalPrice = this.state.isPayTransactionFees ? (
                //     (parseFloat(TotalAmount) - parseFloat(DiscountAmount) - parseFloat(this.state.transactionFee)) + parseFloat(transactionFee) 
                // ) 
                // : (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                // totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
                this.setState({
                    // transactionFee,
                    // TotalAmount: TotalAmount,
                    isPromocodeRemoved: true,
                    PromocodeError: false,
                    PromocodeApplied: false,
                    isPromoCodeEditable: true,
                    // DiscountAmount: 0,
                    DiscountCode: ''

                    // TotalAmount: (TotalAmount - nextprops.PromocodeAdded).toFixed(2)
                })
            }
        }
        if (this.props.PromocodeError !== nextprops.PromocodeError) {
            if (nextprops.PromocodeError) {
                this.setState({
                    PromocodeError: true
                })
            }
        }
        if (this.props.response !== nextprops.response) {
            if (nextprops.response) {
                this.setState({
                    membershipRecords: nextprops.response,
                });
            }
        }
        if (this.props.createdPayments !== nextprops.createdPayments) {
            if (nextprops.createdPayments) {
                this.setState({
                    createdPayments: nextprops.createdPayments,
                    current: 3,
                });
            }
        }
        if (this.props.initTransaction !== nextprops.initTransaction) {
            if (nextprops.initTransaction) {
                let isPromoCodeEditable = !this.state.PromocodeApplied;
                this.setState({
                    isPromoCodeEditable,
                    current: 4,
                });
            }
        }

        if (this.props.nesa_reg !== nextprops.nesa_reg) {
            let nesareg = nextprops.nesa_reg ? nextprops.nesa_reg : []
            let nesalevels = nextprops.nesa_levels ? nextprops.nesa_levels : [];

            let membership_Type = '';
            let membershipId = '';
            let expiryDate = '';
            let currentDate = new Date();

            if (nesareg.length == 0 && nesareg != "error") {
                const isApplicableForNewEagle = this.checkApplicableForNewEagle(this.state.selectedRecord.eagleBoardReviewDate);
                this.setState({
                            doesShowNewMemberGreetings: isApplicableForNewEagle,
                            isApplicableForNewEagle
                })
            } else {
                this.setState({
                    doesShowNewMemberGreetings: false,
                    isApplicableForNewEagle: false
                 })
            }

            if (nesareg.length != 0 && nesalevels.length != 0 && nesareg != "error") {
                let haveLifeTime = nesareg.find(item => item.programId.toString() == '32')
                if (haveLifeTime) {
                    this.setState({
                        existingLifePlan: true
                    })
                } else {
                    nesareg.map((k, index) => {
                        if (k.isActive === true) {
                            membershipId = k.programId
                            expiryDate = k.expireDate

                            nesalevels.map((j, index) => {
                                if (parseInt(j.id) == membershipId) {
                                    membership_Type = j.name;
                                }
                            })
                        }
                    })
                    if (moment(new Date(expiryDate)).isAfter(new Date(currentDate))) {
                        history.push({ pathname: "/renew-membership", state: { renewMembership: true, scouts_DOB: this.state.scouts_DOB, SelectedMembershipName: this.state.SelectedMembershipName, redirectedFrom: 'gift-membership' } })
                    }
                }
            }
        }

        if (this.props.searchedEagle !== nextprops.searchedEagle 
            && (Array.isArray(nextprops.searchedEagle) && nextprops.searchedEagle.length > 0) 
            && this.state.lookupsLoaded) 
            {

            let searchedEagle = nextprops.searchedEagle;
                let filterSearchedEagle = searchedEagle.filter((each) => {
                    return (
                        each.eagleBoardReviewDate != "" &&
                        each.eagleBoardReviewDate != null &&
                        each.eagleCertificationDate != "" &&
                        each.eagleCertificationDate != null &&
                        each.memberId != "" &&
                        each.memberId != null
                    );
                });
                // let filterSearchedEagle = searchedEagle
                if (this.props.allstates) {
                    filterSearchedEagle.map((eachRec) => {
                        this.props.allstates.map((item) => {
                            if (item.short == eachRec.state) {
                                eachRec.stateId = item.id;
                            }
                        });
                    });
                }

                //let length = searchedEagle.length;
                let length = filterSearchedEagle.length;
                //AAG-971 Remove 'Scout's Phone Number from NESA application process
                // let phoneCountryId = "";
                // let PhoneNumber = "";
                // if (length > 0 && filterSearchedEagle[0].phone.length == 13) {
                //     let getCountryShort = filterSearchedEagle[0].phone.slice(0, 3).toString();
                //     if (this.props.countries) {
                //         this.props.countries.map((code) => {
                //             if (getCountryShort == code.short) {
                //                 phoneCountryId = code.short;
                //             }
                //         });
                //     }
                //     PhoneNumber = filterSearchedEagle[0].phone.slice(3);
                // } else if (length > 0) {
                //     PhoneNumber = filterSearchedEagle[0].phone.replace(/ /g, "");
                // }

                if (length === 0) {
                    this.show_NoResultsFound_Modal();
                } else {
                    this.setState({ NoResultsFound: false });
                }

                if (length == 1) {
                    if (filterSearchedEagle[0].isDeceased) {
                        this.setState({
                            isDeceasedPerson: true
                        })
                    } else {
                        if (
                            filterSearchedEagle[0].ineligibleFlag &&
                            filterSearchedEagle[0].ineligibleFlag === true
                        ) {
                            this.showIneligibleNESAModal();
                        } else {
                            let getValidEagleDetails = this.getValidScoutCityStateHandler(
                                filterSearchedEagle[0].state,
                                filterSearchedEagle[0].city
                            );


                            this.props.actions.getNESARegistrations(filterSearchedEagle[0].personGuid, true);
                            const current = this.state.current + 1;
                            this.setState(
                                {
                                    current,
                                    isDeceasedPerson: filterSearchedEagle[0].isDeceased,
                                    personGUID: searchedEagle[0].personGuid,
                                    EagleResults: filterSearchedEagle,
                                    selectedRecord: filterSearchedEagle[0],
                                    scoutsCountry: filterSearchedEagle[0].countryId,
                                    // phoneCountryId, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                                    // PhoneNumber,
                                    getValidScoutState: getValidEagleDetails.getValidScoutState,
                                    getValidScoutCity: getValidEagleDetails.getValidScoutCity,
                                    userDetails: filterSearchedEagle[0]
                                }
                            );
                        }
                    }
                }
                if (length > 1) {
                    this.showResults();
                    let getValidEagleDetails = this.getValidScoutCityStateHandler(
                        filterSearchedEagle[0].state,
                        filterSearchedEagle[0].city
                    );
                    this.setState({
                        // showResultModal: true,
                        // phoneCountryId, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                        // PhoneNumber,
                        selectedRecord: filterSearchedEagle[0],
                        scoutsCountry: filterSearchedEagle[0].countryId,
                        EagleResults: filterSearchedEagle,
                        personGUID: filterSearchedEagle[0].personGuid,
                        getValidScoutState: getValidEagleDetails.getValidScoutState,
                        getValidScoutCity: getValidEagleDetails.getValidScoutCity,
                    });
                    //this.showSearchStatus('More Record Found!', 'More than one record was found, please provide your Member ID.')
                }
                // if (length === 0)
                //    this.show_NoResultsFound_Modal()
                
            }
            if (this.props.searchedEagle !== nextprops.searchedEagle 
                && (Array.isArray(nextprops.searchedEagle) && nextprops.searchedEagle.length == 0)) 
                {
                    //show no record found popup
                    this.show_NoResultsFound_Modal()

            }

            
    };

    showIneligibleNESAModal = () => {
        this.setState({
            isIneligible: true,
        });
    };

    closeIneligibleNESAModal = () => {
        this.setState({
            isIneligible: false,
        });
        // window.location.assign("https://nesa.org/");
    };

    show_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: true,
        });
    };
    close_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: false,
        });
        // window.location.assign('https://nesa.org/')
    };
    show_no_identifying_information_PopUp = () => {
        this.setState({
            noIdentifyingInformation: true,
        });
    };
    close_no_identifying_information_PopUp = () => {
        this.setState({
            noIdentifyingInformation: false,
        });
        // window.location.assign("https://nesa.org/");
    };

    showSearchStatus = (title, text) => {
        Modal.warning({
            title: title,
            content: text,
        });
    };

    showResults = () => {
        this.setState({
            showResultModal: true,
        });
    };

    closeResult = () => {
        this.setState({
            showResultModal: false,
        });
    };


    closeExistingLifePlanModal = () => {
        this.setState({
            existingLifePlan: false,
            current: 1
        })
        // history.push('/')

    }
    changeAlternateShippingAddress = (e) => {
        if(e.target.checked) {
            this.setState(({isShippingAddress: true})) 
        }else {
            this.setState(({isShippingAddress: false}))
        }
    }

    changeScoutsCountry = (e) => {
        this.setState({
            scoutsCountry: e,
        })
    }
    renderPrimaryOrAlternateAddress = () => {

        return <ScoutsPrimaryOrAlternateAddress
            form={this.props.form}
            selectedRecord={this.state.selectedRecord}
            scoutsCountry={this.state.scoutsCountry}
            phoneCountryId={this.state.phoneCountryId}
            changeScoutsCountryEventHandler={this.changeScoutsCountry}
            isShippingAddress={this.state.isShippingAddress}
            // changeAlternateShippingAddressEventHandler={this.changeAlternateShippingAddress}
            isRedirectedFromGift={true}
        />
    }

    renderEagleInfo = () => {
        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            return (
                <Row gutter={48}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <FormItem hasFeedback label="Eagle Scout Board of Review Date">
                            {getFieldDecorator("reviewdate", {
                                initialValue: this.state.selectedRecord.eagleBoardReviewDate
                                    ? moment(
                                        this.state.selectedRecord.eagleBoardReviewDate
                                    ).format("MM/DD/YYYY")
                                    : "",
                                rules: [
                                    {
                                        required: true,
                                        message: "Enter Eagle Scout Board of Review Date!",
                                    },
                                ],
                            })(
                                <Input
                                    placeholder="MM/DD/YYYY"
                                    className={
                                        this.state.selectedRecord.eagleBoardReviewDate
                                            ? "input-disabled"
                                            : ""
                                    }
                                    disabled={
                                        this.state.selectedRecord.eagleBoardReviewDate
                                            ? true
                                            : false
                                    }
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <FormItem hasFeedback label="Eagle Scout Unit Number">
                            {getFieldDecorator("troopnumber", {
                                initialValue: this.state.selectedRecord.unitNumber
                                    ? this.state.selectedRecord.unitNumber
                                    : "",
                                rules: [
                                    {
                                        // required: true,
                                        message: "Enter Eagle Scout Unit Number!",
                                    },
                                ],
                            })(
                                <Input
                                    className={
                                        this.state.selectedRecord.unitNumber ? "input-disabled" : ""
                                    }
                                    disabled={this.state.selectedRecord.unitNumber ? true : false}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <FormItem hasFeedback label="Eagle Scout Unit City">
                            {getFieldDecorator("scout_city", {
                                initialValue: this.state.selectedRecord.eagleCity
                                    ? this.state.selectedRecord.eagleCity
                                    : "",
                                rules: [
                                    {
                                        //  required: true,
                                        message: "Enter Eagle Scout City!",
                                    },
                                ],
                            })(
                                <Input
                                    className={
                                        this.state.selectedRecord.eagleCity ? "input-disabled" : ""
                                    }
                                    disabled={this.state.selectedRecord.eagleCity ? true : false}
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <FormItem hasFeedback label="Eagle Scout Unit State">
                            {getFieldDecorator("scout_state", {
                                initialValue: this.state.selectedRecord.eagleState
                                    ? this.state.selectedRecord.eagleState
                                    : "",
                                rules: [
                                    {
                                        // required: true,
                                        message: "Enter Eagle Scout State!",
                                    },
                                ],
                            })(
                                <Input
                                    className={
                                        this.state.selectedRecord.eagleState ? "input-disabled" : ""
                                    }
                                    disabled={this.state.selectedRecord.eagleState ? true : false}
                                />
                            )}
                        </FormItem>
                    </Col>
                </Row>
            );
        } else {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Scout's Eagle Information..."
                        />
                    </Col>
                </Row>
            );
        }
    };

    renderPII = () => {
        if (this.props.searching) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Eagle information..."
                        />
                    </Col>
                </Row>
            );
        }
        if (this.state.selectedRecord) {
            const { getFieldDecorator } = this.props.form;
            let eagleinfo = this.state.selectedRecord;
            let ethnicShort = this.state.selectedRecord.ethnicity;
            let ethnicBackground = undefined;
            if (ethnicShort != "" && this.props.ethnicities) {
                this.props.ethnicities.map((each) => {
                    if (each.short == ethnicShort) {
                        ethnicBackground = each.name;
                    }
                });
            }
            return (
                <Row gutter={48} style={{ marginLeft: "0px", marginRight: "0px" }}>
                    <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                            <FormItem hasFeedback label="Scout’s First Name">
                                {getFieldDecorator("firstname", {
                                    initialValue: eagleinfo.firstName ? eagleinfo.firstName : "",
                                    rules: [{ message: "Enter Scout's First Name!" }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="First Name"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout’s middle Name">
                                {getFieldDecorator("middlename", {
                                    initialValue: eagleinfo.middleName
                                        ? eagleinfo.middleName
                                        : "",
                                    rules: [{ message: "Enter Scout's middle Name!" }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="middle Name"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout’s Last Name">
                                {getFieldDecorator("lastname", {
                                    initialValue: eagleinfo.lastName ? eagleinfo.lastName : "",
                                    rules: [{ min: 2, message: "Enter Scout's Last Name!" }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="Last Name"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    {/* Hiding DOB, Gender and MemberID as per changes from AAG-1026 */}
                    {/* <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem
                                hasFeedback
                                label="Scout’s Date of Birth"
                                onClick={() => this.setState({ scouts_DOB_MaskChar: "-" })}
                            >
                                {getFieldDecorator("dob", {
                                    initialValue: this.state.scouts_DOB
                                        ? moment(this.state.scouts_DOB).format("MM/DD/YYYY")
                                        : "",
                                    rules: [
                                        { message: "Enter Date of Birth!" },
                                        {
                                            pattern:
                                                /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                            message: `Please enter correct format MM/DD/YYYY Pattern`,
                                        },
                                    ],
                                })(
                                    <InputMask
                                        style={{ background: "#f5f5f5 " }}
                                        className="input-disabled ant-input"
                                        disabled
                                        mask="99/99/9999"
                                        placeholder="MM/DD/YYYY"
                                        alwaysShowMask
                                        maskChar={this.state.scouts_DOB_MaskChar}
                                        onChange={(e) => {
                                            this.format_Date(e, "DOB");
                                        }}
                                        render={(ref, props) => (
                                            <Input className="input-disabled" disabled />
                                        )}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem hasFeedback label="Scout’s Member ID">
                                {getFieldDecorator("memberid", {
                                    initialValue: eagleinfo.memberId ? eagleinfo.memberId : "",
                                    // rules: [{  min: 2, message: 'Enter Scout\'s Member ID!' }],
                                })(
                                    <Input
                                        disabled
                                        placeholder="Member ID"
                                        className="input-disabled"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                            <FormItem label="Gender">
                                {getFieldDecorator("gender", {
                                    initialValue: this.state.selectedRecord.gender
                                        ? this.state.selectedRecord.gender
                                        : "",
                                    rules: [{ required: true, message: "Enter Scout's Gender!" }],
                                })(
                                    <RadioGroup
                                        name="gender"
                                        disabled={
                                            this.state.selectedRecord.gender != "" ? true : false
                                        }
                                    >
                                        <Radio value="M">Male</Radio>
                                        <Radio value="F">Female</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                    </Row> */}
                    {/* //AAG-971 Remove 'Scout's Phone Number from NESA application process */}
                    {/* <Row gutter={24} style={{ marginLeft: "0px", marginRight: "0px" }}>
                        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                            <FormItem className="ScoutPhoneNumber" hasFeedback
                                label={
                                    <div className="ScoutPhoneUpdateInfo">
                                        Scout’s Phone
                                    <Tooltip
                                            placement="bottom"
                                            title="A telephone number can only be updated on the individual's Spark dashboard."
                                        >
                                            <Icon type="info-circle-o" theme="twoTone" />
                                        </Tooltip>
                                    </div>
                                }>

                                {getFieldDecorator("phone", {
                                    initialValue: this.state.PhoneNumber
                                        ? this.state.PhoneNumber.toString()
                                        : "",
                                    rules: [
                                        {
                                            required: true,
                                            min: 10,
                                            max: 10,
                                            message: "Enter Scout’s Phone Number!",
                                        },
                                        {
                                            pattern: new RegExp("^[0-9]*$"),
                                            message: "Phone Number must be all numeric!",
                                        },
                                    ],
                                })(
                                    <Input
                                        // className={this.state.PhoneNumber ? 'input-disabled' : ''}
                                        // disabled={(this.state.PhoneNumber) ? true : false}
                                        disabled
                                        className="input-disabled"
                                        addonBefore={getFieldDecorator("phonecountryID", {
                                            initialValue: this.state.phoneCountryId
                                                ? `${this.state.phoneCountryId}`
                                                : "636",
                                            // initialValue:  "636",
                                        })(
                                            <Select
                                                disabled
                                                style={{ width: 150 }}
                                                ref={this.selectphonecountryIDRef}
                                                onSelect={() =>
                                                    this.selectphonecountryIDRef.current.blur()
                                                }
                                            >
                                                {this.getPhoneCode()}
                                            </Select>
                                        )}
                                        placeholder="Phone"
                                    />
                                )}
                            </FormItem>
                        </Col>

                        <Col xs={24} sm={24} md={12} lg={6} xl={8}></Col>

                        <Col xs={24} sm={24} md={12} lg={6} xl={8}></Col>
                    </Row> */}
                </Row>
            );
        } else {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Scout's Personal Information..."
                        />
                    </Col>
                </Row>
            );
        }
    };

    renderSearchResults = () => {
        if (this.state.EagleResults.length !== 0) {
            return this.state.EagleResults.map((eagle, i) => {
                return (
                    <div
                        className={
                            this.state.memberSelectedKey == i
                                ? "eagle-results-active"
                                : "eagle-results"
                        }
                        key={i}
                        onClick={() => {
                                if (eagle.isDeceased) {
                                this.setState({isDeceasedPerson: true})
                            } else {
                            this.SelectedMemberRecord(eagle, i)
                            this.props.actions.getNESARegistrations(eagle.personGuid, true);
                            }
                        }}
                    >
                        <Row>
                            <Col xs={23}>
                                <Row>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Scout Name: </b>
                                        </span>
                                        <span>

                                            {eagle.firstName} {eagle.middleName} {eagle.lastName}
                                        </span>
                                    </Col>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Member ID: </b>
                                        </span>
                                        <span> {eagle.memberId}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Board of Review Date: </b>
                                        </span>
                                        <span>

                                            {eagle.eagleBoardReviewDate
                                                ? eagle.eagleBoardReviewDate
                                                : "---"}
                                        </span>
                                    </Col>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Awarding Council: </b>
                                        </span>
                                        <span>

                                            {eagle.awardingCouncilName
                                                ? eagle.awardingCouncilName
                                                : "---"}
                                        </span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Council Unit Number: </b>
                                        </span>
                                        <span>{eagle.unitNumber ? eagle.unitNumber : "---"}</span>
                                    </Col>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Council City: </b>
                                        </span>
                                        <span> {eagle.eagleCity ? eagle.eagleCity : "---"}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={12} lg={12}>
                                        <span>
                                            <b>Council State: </b>
                                        </span>
                                        <span> {eagle.eagleState ? eagle.eagleState : "---"} </span>
                                    </Col>
                                </Row>
                            </Col>
                            {this.state.memberSelectedKey == i ? (
                                <Col xs={1}>
                                    <i
                                        className="fa fa-check-circle margin-right-10 fa-2x SelectedRecord pointer"
                                        aria-hidden="true"
                                    ></i>
                                </Col>
                            ) : (
                                ""
                            )}
                        </Row>
                    </div>
                );
            });
        }
    };

    retryToLoadFailedLookups = () => {
        if(this.props.ethnicitiesError) this.props.actions.getEthnicities();
        if(this.props.productpriceError) this.props.actions.getProductPrice();
        if(this.props.nesa_levelsError) this.props.actions.getNESAmembershiplevels();
        if(this.props.allstatesError) this.props.actions.getStates();
        if(this.props.countriesError) this.props.actions.getCountries();
        if(this.props.phonecodeError) this.props.actions.getPhoneCountries();

        this.setState({
            showLookupError: false,
            pageLoader: true
        })
    }

    SelectedMemberRecord = (record, i) => {
        if (record.ineligibleFlag && record.ineligibleFlag === true) {
            this.showIneligibleNESAModal();
        } else {
            //AAG-971 Remove 'Scout's Phone Number from NESA application process
            // let phoneCountryId = "",
            //     PhoneNumber = "";

            // if (record.phone.length == 13) {
            //     let getCountryShort = record.phone.slice(0, 3).toString();
            //     if (this.props.countries) {
            //         this.props.countries.map((code) => {
            //             if (getCountryShort == code.short) {
            //                 phoneCountryId = code.short;
            //             }
            //         });
            //     }
            //     PhoneNumber = record.phone.slice(3);
            // } else {
            //     PhoneNumber = record.phone;
            // }


            let getValidEagleDetails = this.getValidScoutCityStateHandler(
                record.state,
                record.city
            );

            this.setState({
                // phoneCountryId,
                // PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application processs
                scoutsCountry: record.countryId,
                memberSelectedKey: i,
                selectedRecord: record,
                personGUID: record.personGuid,
                getValidScoutState: getValidEagleDetails.getValidScoutState,
                getValidScoutCity: getValidEagleDetails.getValidScoutCity
            });
        }
    };

    SelectEagle = () => {
        this.setState({
            showResultModal: false,
            current: this.state.current + 1,
        });
    };

    componentWillUnmount() {
        clearInterval(this.loadingInterval);
    }

    // render_nonUSA_address = () => {

    //     const { getFieldDecorator } = this.props.form;
    //     const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

    //     return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem
    //                     label="Scout’s Country"
    //                 >
    //                     {getFieldDecorator('countryId', {
    //                         initialValue: this.state.scoutsCountry,
    //                         //  initialValue: "616",
    //                         rules: [{ required: true, message: 'Enter Scout’s Country!' }],
    //                     })(
    //                         <Select
    //                             showAction={['focus', 'click']}
    //                             showSearch
    //                             style={{ width: '100%' }}
    //                             placeholder="Select a Country"
    //                             optionFilterProp="children"
    //                             onChange={(e) => {
    //                                 this.setState({
    //                                     scoutsCountry: e,
    //                                 })
    //                             }}
    //                             filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    //                         >
    //                             {this.countries()}
    //                         </Select>
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label={(
    //                         <span>
    //                             Address Line 1&nbsp;
    //                             <Tooltip placement="top" title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)">
    //                                 <Icon type="info-circle-o" />
    //                             </Tooltip>
    //                         </span>
    //                     )}
    //                 >
    //                     {getFieldDecorator('addressline1', {
    //                         initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
    //                         rules: [{ required: true, message: 'Enter Scout’s Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 1" />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     style={{ marginBottom: '0px' }}
    //                     label={(
    //                         <span>
    //                             Address Line 2&nbsp;
    //                             <Tooltip placement="top" title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)">
    //                                 <Icon type="info-circle-o" />
    //                             </Tooltip>
    //                         </span>
    //                     )}
    //                 //extra="City, Territory, Postal Code, Country"
    //                 >
    //                     {getFieldDecorator('addressline2', {
    //                         initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
    //                         rules: [{ required: false, message: 'Enter Scout’s Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 2" />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     style={{ marginBottom: '0px' }}
    //                     label={(
    //                         <span>
    //                             Address Line 3&nbsp;
    //                             <Tooltip placement="top" title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver, BC V5X 2H6">
    //                                 <Icon type="info-circle-o" />
    //                             </Tooltip>
    //                         </span>
    //                     )}
    //                     extra="City, Territory, Postal Code, Country"
    //                 >
    //                     {getFieldDecorator('addressline3', {
    //                         initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
    //                         rules: [{ required: true, message: 'Enter Scout’s Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 3" />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Email"
    //                 >
    //                     {getFieldDecorator('email', {
    //                         initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
    //                         rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
    //                     })(
    //                         <Input placeholder="Email" />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Phone"
    //                 >
    //                     {getFieldDecorator('phone', {
    //                         initialValue: (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : "",
    //                         rules: [{ required: true, min: 10, max: 10, message: 'Enter Scout’s Phone Number!' },
    //                         {
    //                             pattern: new RegExp("^[0-9]*$"),
    //                             message: "Phone Number must be all numeric!"
    //                         }],
    //                     })(
    //                         <Input
    //                             // className={this.state.PhoneNumber ? 'input-disabled' : ''}
    //                             // disabled={(this.state.PhoneNumber) ? true : false}
    //                             addonBefore={
    //                                 getFieldDecorator('phonecountryID', {
    //                                     initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
    //                                     // initialValue:  "636",
    //                                 })(
    //                                     <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()} >
    //                                         {this.getPhoneCode()}
    //                                     </Select>
    //                                 )
    //                             } value="" />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //         </Row>
    //     </Row>
    //     )
    // }
    // render_USA_address = () => {

    //     const { getFieldDecorator } = this.props.form;
    //     const stateInputEle = () => { return <input maxLength={2} style={{ textTransform: 'uppercase' }} autoComplete={'off'} /> };

    //     return (<Row gutter={48} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem
    //                     label="Scout’s Country"
    //                 >
    //                     {getFieldDecorator('countryId', {
    //                         initialValue: this.state.scoutsCountry ? `${this.state.scoutsCountry}` : "616",
    //                         //  initialValue: "616",
    //                         rules: [{ required: true, message: 'Enter Scout’s Country!' }],
    //                     })(
    //                         <Select
    //                             showAction={['focus', 'click']}
    //                             showSearch
    //                             style={{ width: '100%' }}
    //                             placeholder="Select a Country"
    //                             optionFilterProp="children"
    //                             onChange={(e) => {
    //                                 this.setState({
    //                                     scoutsCountry: e,
    //                                 })
    //                             }}
    //                             filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    //                         >
    //                             {this.countries()}
    //                         </Select>
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Address Line 1"
    //                 >
    //                     {getFieldDecorator('addressline1', {
    //                         initialValue: this.state.selectedRecord.address1 ? this.state.selectedRecord.address1 : "",
    //                         rules: [{ required: true, message: 'Enter Scout’s Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 1" />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Address Line 2"
    //                 >
    //                     {getFieldDecorator('addressline2', {
    //                         initialValue: this.state.selectedRecord.address2 ? this.state.selectedRecord.address2 : "",
    //                         rules: [{ required: false, message: 'Enter Scout’s Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 2" />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Address Line 3"
    //                 >
    //                     {getFieldDecorator('addressline3', {
    //                         initialValue: this.state.selectedRecord.address3 ? this.state.selectedRecord.address3 : "",
    //                         rules: [{ required: false, message: 'Enter Scout’s Address!' }],
    //                     })(
    //                         <Input placeholder="Address Line 3" />
    //                     )}
    //                 </FormItem>
    //             </Col>

    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s City"
    //                 >
    //                     {getFieldDecorator('city', {
    //                         initialValue: this.state.selectedRecord.city ? this.state.selectedRecord.city : "",
    //                         rules: [{ required: true, min: 2, message: 'Enter Scout’s City!' }],
    //                     })(
    //                         <Input placeholder="City" />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s State"
    //                 >
    //                     {getFieldDecorator('state', {
    //                         initialValue: this.state.selectedRecord.stateId ? `${this.state.selectedRecord.stateId}` : "",
    //                         rules: [{ required: true, message: 'Enter Scout’s State!' }],
    //                     })(
    //                         <Select
    //                             getInputElement={stateInputEle}
    //                             showAction={['focus', 'click']}
    //                             showSearch
    //                             style={{ width: '100%', textTransform: 'uppercase' }}
    //                             placeholder="Select a State"
    //                             optionFilterProp="children"
    //                             filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    //                         >
    //                             {this.statesID()}
    //                         </Select>
    //                     )}
    //                 </FormItem>
    //             </Col>
    //         </Row>

    //         <Row gutter={24} style={{ marginLeft: '0px', marginRight: '0px' }}>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s ZIP Code"
    //                 >
    //                     {getFieldDecorator('zipcode', {
    //                         initialValue: this.state.selectedRecord.zipCode ? this.state.selectedRecord.zipCode.toString() : "",
    //                         rules: [{ required: true, max: 5, min: 5, message: 'Enter Scout’s ZIP Code!' }],
    //                     })(
    //                         <InputMask
    //                             mask="99999"
    //                             placeholderChar=""
    //                             className="ant-input"
    //                             render={(ref, props) => (

    //                                 <Input placeholder="ZIP Code" style={{ background: '#f5f5f5 ' }}

    //                                 />

    //                             )}
    //                         />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Phone"
    //                 >
    //                     {getFieldDecorator('phone', {
    //                         initialValue: (this.state.PhoneNumber) ? this.state.PhoneNumber.toString() : "",
    //                         rules: [{ required: true, min: 10, max: 10, message: 'Enter Scout’s Phone Number!' },
    //                         {
    //                             pattern: new RegExp("^[0-9]*$"),
    //                             message: "Phone Number must be all numeric!"
    //                         }],
    //                     })(
    //                         <Input
    //                             // className={this.state.PhoneNumber ? 'input-disabled' : ''}
    //                             // disabled={(this.state.PhoneNumber) ? true : false}
    //                             addonBefore={
    //                                 getFieldDecorator('phonecountryID', {
    //                                     initialValue: this.state.phoneCountryId ? `${this.state.phoneCountryId}` : "636",
    //                                     // initialValue:  "636",
    //                                 })(
    //                                     <Select style={{ width: 100 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()} >
    //                                         {this.getPhoneCode()}
    //                                     </Select>
    //                                 )
    //                             } value="" />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //             <Col xs={24} sm={24} md={12} lg={12} xl={8}>
    //                 <FormItem hasFeedback
    //                     label="Scout’s Email"
    //                 >
    //                     {getFieldDecorator('email', {
    //                         initialValue: this.state.selectedRecord.email ? this.state.selectedRecord.email : "",
    //                         rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
    //                     })(
    //                         <Input placeholder="Email" />
    //                     )}
    //                 </FormItem>
    //             </Col>
    //         </Row>
    //     </Row>
    //     )
    // }
    render() {
        const { current } = this.state;
        const { minutes, seconds } = this.state;
        const { getFieldDecorator } = this.props.form;
        const stateInputEle = () => {
            return (
                <input
                    maxLength={2}
                    style={{ textTransform: "uppercase" }}
                    autoComplete={"off"}
                />
            );
        };

        return (
            <div>
                <NESAHeader />

                <div className="step-widget">
                    <div className="step-container">
                        <div className="step-background">
                            <Row type="flex" align="center" justify="center">
                                <Steps current={current}>
                                    <Step key="level" title="Eagle Level" />
                                    <Step key="eagle-search" title="Eagle Search" />
                                    <Step key="eagle-info" title="Eagle Info" />
                                    <Step key="payment-Summary" title="Summary" />
                                    <Step key="payment" title="Payment" />
                                    <Step key="receipt" title="Receipt" />
                                </Steps>
                            </Row>
                        </div>
                        <div className="steps-content centered">
                            {this.state.current == 0 && (
                                <div className="centered steps-form1">
                                    <Row type="flex" justify="center" align="center">
                                        <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                            <img src="../NESA.png" className="NESA-logo" />
                                        </Col>
                                        <Col span={24} className="center">
                                            <span className="welcome-text">
                                                We’re glad you are here!
                                            </span>
                                        </Col>
                                        <Col span={24} className="center">
                                            <span className="thank-you">
                                                Thank you for supporting current and future Eagle Scouts
                                                with your purchase.
                                            </span>
                                            <span className="thank-you b">
                                                Select the level and term you would like to purchase.
                                            </span>
                                        </Col>
                                        <Col className="card-margin" span={24}>
                                            <Row gutter={48} className="welcome-nesa-col">{this.renderLevels()}</Row>
                                        </Col>
                                    </Row>
                                    <div className="text-result pointer"
                                        style={{ marginTop: "55px", marginBottom: '55px' }}
                                        onClick={() => {
                                            window.location.assign('https://nesa.org/take-action/join-us/')
                                        }}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i> Back to NESA.org/ Join</div>
                                </div>
                            )}
                            {this.state.current == 1 && (
                                <div className="centered">
                                    <Form
                                        onSubmit={this.handleSearchSubmit}
                                        className="search-form alumni-ui"
                                    >
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className="NESA-logo" />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="welcome-text"> WELCOME </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="thank-you">
                                                    Thank you for your interest in supporting NESA
                                                </span>
                                            </Col>

                                            <Col className="card-margin search-alumni" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Scout's Personal Information"
                                                >
                                                    <Row gutter={48}>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem label="Scout’s First Name" hasFeedback>
                                                                {getFieldDecorator("scout_first_name", {
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message: "Enter Scout First Name!",
                                                                        },
                                                                    ],
                                                                })(<Input placeholder="First Name" />)}
                                                            </FormItem>
                                                        </Col>
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Scout’s Middle Name"
                                                                hasFeedback
                                                            >
                                                                {getFieldDecorator('scout_middle_Initial', {
                                                                    rules: [{ required: false, message: 'Enter Scout Middle Name!' }],
                                                                })(
                                                                    <Input placeholder="Middle Name" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem label="Scout’s Last Name" hasFeedback>
                                                                {getFieldDecorator("scout_last_name", {
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message: "Enter Scout Last Name!",
                                                                        },
                                                                    ],
                                                                })(<Input placeholder="Last Name" />)}
                                                            </FormItem>
                                                        </Col>
                                                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Scout’s Date of Birth"
                                                                hasFeedback
                                                                onClick={() =>
                                                                    this.setState({ scouts_DOB_MaskChar: "-" })
                                                                }
                                                            >
                                                                {getFieldDecorator("scout_dob", {
                                                                    initialValue: "",
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message: "Enter Scout Date of Birth!",
                                                                        },
                                                                        {
                                                                            pattern:
                                                                                /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                                            message: `Please enter correct format MM/DD/YYYY Pattern`,
                                                                        },
                                                                    ],
                                                                })(
                                                                    // <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" onChange={(value) => this.setDOB(value)} />
                                                                    <InputMask
                                                                        mask="99/99/9999"
                                                                        placeholder="MM/DD/YYYY"
                                                                        alwaysShowMask
                                                                        maskChar={this.state.scouts_DOB_MaskChar}
                                                                        className="ant-input"
                                                                        // value={this.state.scouts_DOB}
                                                                        onChange={(e) => {
                                                                            this.format_Date(e, "scout_dob");
                                                                        }}
                                                                        render={(ref, props) => <Input />}
                                                                    />
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                        {/* <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                            <FormItem
                                                                label="Scout’s Member ID"
                                                            >
                                                                {getFieldDecorator('scout_member_id', {
                                                                    rules: [{ required: false, message: 'Enter Scout Member ID!' }],
                                                                })(
                                                                    <Input placeholder="Member ID" />
                                                                )}
                                                            </FormItem>
                                                        </Col> */}
                                                    </Row>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <div
                                            className="steps-action centered backto-levels"
                                            style={{ width: "60%" }}
                                        >
                                            <Row style={{ position: "unset" }}>
                                                <Col
                                                    className="xs-center sm-center"
                                                    xs={24}
                                                    sm={24}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    <FormItem>
                                                        <Button
                                                            type="primary"
                                                            className="back-btn pointer"
                                                            id="backToSearch-btn"
                                                            onClick={() => {
                                                                let total = (
                                                                    Math.round(
                                                                        (parseFloat(
                                                                            this.state.SelectedMembershipPrice
                                                                        ) +
                                                                            parseFloat(
                                                                                this.state.shipping_handlingCharge
                                                                            )) *
                                                                        100
                                                                    ) / 100
                                                                ).toFixed(2);
                                                                this.setState({
                                                                    isPayTransactionFees: false,
                                                                    TotalAmount: total,
                                                                });
                                                                this.prev();
                                                            }}
                                                        >
                                                            Back to: Eagle Level
                                                        </Button>
                                                    </FormItem>
                                                </Col>
                                                <Col
                                                    className="xs-center sm-center"
                                                    xs={24}
                                                    sm={24}
                                                    md={12}
                                                    lg={12}
                                                    xl={12}
                                                >
                                                    {this.renderSearchButton()}
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                            )}
                            {this.state.current == 2 && (
                                <div className="centered steps-form search-form">
                                    <Form
                                        onSubmit={this.handleSubmit}
                                        className="gift-form alumni-ui"
                                    >
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className="NESA-logo" />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="welcome-text"> WELCOME </span>
                                            </Col>
                                            <Col span={16} className="center">
                                                <span className="thank-you">
                                                    Thank you for your interest in supporting NESA, please
                                                    provide the scout’s information for which you are
                                                    applying for a Gift-Membership.
                                                </span>
                                            </Col>
                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Scout's Personal Information"
                                                >
                                                    {this.renderPII()}
                                                </Card>
                                            </Col>

                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Eagle Scout Information"
                                                >
                                                    {this.renderEagleInfo()}
                                                </Card>
                                            </Col>

                                            <Col className="card-margin" span={24}>
                                                {this.renderPrimaryOrAlternateAddress()}
                                            </Col>

                                            {/* <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Scout’s Address Information"

                                                >
                                                    {this.state.scoutsCountry != '616' || this.state.scoutsCountry != 616 ?
                                                        this.render_nonUSA_address() : this.render_USA_address()
                                                    }

                                                </Card>
                                            </Col> */}

                                            <Col className="card-margin" span={24}>
                                                <Card className="centered" title="Your Information">
                                                    <Row
                                                        gutter={48}
                                                        style={{ marginLeft: "0px", marginRight: "0px" }}
                                                    >
                                                        <Row
                                                            gutter={24}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="First Name">
                                                                    {getFieldDecorator("g_first_name", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "Enter Your First Name!",
                                                                            },
                                                                        ],
                                                                    })(<Input placeholder="First Name" />)}
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="Last Name">
                                                                    {getFieldDecorator("g_last_name", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                min: 2,
                                                                                message: "Enter Your Last Name!",
                                                                            },
                                                                        ],
                                                                    })(<Input placeholder="Last Name" />)}
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="Phone" required={String(this.state.yoursCountry) !== "616"}>
                                                                    {getFieldDecorator("g_phone", {
                                                                        rules: [
                                                                            {
                                                                                validator: (rule, value, callback) => {

                                                                                    const country =
                                                                                        this.props.form.getFieldValue("g_countryId");

                                                                                    if (
                                                                                        String(country) !== "616" &&
                                                                                        !value
                                                                                    ) {
                                                                                        callback("Enter Your Phone Number!");
                                                                                        return;
                                                                                    }

                                                                                    callback();
                                                                                }
                                                                            },
                                                                            {
                                                                                min: 4,
                                                                                max: 10,
                                                                                message: "Enter Your Phone Number!"
                                                                            },
                                                                            {
                                                                                pattern: /^[0-9]*$/,
                                                                                message: "Phone Number must be all numeric!"
                                                                            }
                                                                        ],
                                                                    })(
                                                                        <Input
                                                                            addonBefore={getFieldDecorator(
                                                                                "g_phonecountryID",
                                                                                {
                                                                                    initialValue: "636",
                                                                                }
                                                                            )(
                                                                                <Select
                                                                                    style={{ width: 100 }}
                                                                                    ref={this.selectphonecountryIDRef}
                                                                                    onSelect={() =>
                                                                                        this.selectphonecountryIDRef.current.blur()
                                                                                    }
                                                                                >
                                                                                    {this.getPhoneCode()}
                                                                                </Select>
                                                                            )}
                                                                            placeholder="Phone"
                                                                        />
                                                                    )}
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                        <Row
                                                            gutter={24}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem hasFeedback label="Email">
                                                                    {getFieldDecorator("g_email", {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                type: "email",
                                                                                message: "Enter a valid email address!",
                                                                            },
                                                                        ],
                                                                    })(<Input placeholder="Email" value="" />)}
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                <FormItem label="Country">
                                                                    {getFieldDecorator("g_countryId", {
                                                                        initialValue: this.state.yoursCountry
                                                                            ? this.state.yoursCountry
                                                                            : "616",
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: "Enter your Country!",
                                                                            },
                                                                        ],
                                                                    })(
                                                                        <Select
                                                                            showAction={["focus", "click"]}
                                                                            showSearch
                                                                            onChange={(e) => {
                                                                            this.setState(
                                                                                {
                                                                                    yoursCountry: e,
                                                                                },
                                                                                () => {
                                                                                    if (String(e) === "616") {
                                                                                        this.props.form.setFields({
                                                                                            g_phone: {
                                                                                                value: this.props.form.getFieldValue("g_phone"),
                                                                                                errors: undefined,
                                                                                            },
                                                                                        });
                                                                                    } else {
                                                                                        this.props.form.validateFields(["g_phone"], {
                                                                                            force: true,
                                                                                        });
                                                                                    }
                                                                                }
                                                                            );
                                                                        }}
                                                                            style={{ width: "100%" }}
                                                                            placeholder="Select a Country"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) =>
                                                                                option.props.children
                                                                                    .toLowerCase()
                                                                                    .indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                        >
                                                                            {this.countries()}
                                                                        </Select>
                                                                    )}
                                                                </FormItem>
                                                            </Col>
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="Address Line 1">
                                                                        {getFieldDecorator("g_address_line_1", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 1" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            ) : (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem
                                                                        hasFeedback
                                                                        label={
                                                                            <span>
                                                                                Address Line 1&nbsp;
                                                                                <Tooltip
                                                                                    placement="top"
                                                                                    title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)"
                                                                                >
                                                                                    <Icon type="info-circle-o" />
                                                                                </Tooltip>
                                                                            </span>
                                                                        }
                                                                    >
                                                                        {getFieldDecorator("g_address_line_1", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 1" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                        <Row
                                                            gutter={24}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="Address Line 2">
                                                                        {getFieldDecorator("g_address_line_2", {
                                                                            rules: [
                                                                                {
                                                                                    required: false,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 2" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            ) : (
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem
                                                                        hasFeedback
                                                                        style={{ marginBottom: "0px" }}
                                                                        label={
                                                                            <span>
                                                                                Address Line 2&nbsp;
                                                                                <Tooltip
                                                                                    placement="top"
                                                                                    title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)"
                                                                                >
                                                                                    <Icon type="info-circle-o" />
                                                                                </Tooltip>
                                                                            </span>
                                                                        }
                                                                    //extra="City, Territory, Postal Code, Country"
                                                                    >
                                                                        {getFieldDecorator("g_address_line_2", {
                                                                            rules: [
                                                                                {
                                                                                    required: false,
                                                                                    message: "Enter Address!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Address Line 2" />)}
                                                                    </FormItem>
                                                                </Col>
                                                            )}
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                <span>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="City">
                                                                            {getFieldDecorator("g_city", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        min: 2,
                                                                                        message: "Enter City!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="City" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="State">
                                                                            {getFieldDecorator("g_state", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter State!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <Select
                                                                                    getInputElement={stateInputEle}
                                                                                    showAction={["focus", "click"]}
                                                                                    showSearch
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        textTransform: "uppercase",
                                                                                    }}
                                                                                    placeholder="Select a State"
                                                                                    optionFilterProp="children"
                                                                                    filterOption={(input, option) =>
                                                                                        option.props.children
                                                                                            .toLowerCase()
                                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                                    }
                                                                                >
                                                                                    {this.statesID()}
                                                                                </Select>
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem
                                                                            hasFeedback
                                                                            style={{ marginBottom: "0px" }}
                                                                            label={
                                                                                <span>
                                                                                    Address Line 3&nbsp;
                                                                                    <Tooltip
                                                                                        placement="top"
                                                                                        title="List the city, territory and country according to country standards (Southampton, SO53 5PD, UK; Vancouver"
                                                                                    >
                                                                                        <Icon type="info-circle-o" />
                                                                                    </Tooltip>
                                                                                </span>
                                                                            }
                                                                            extra="City, Territory, Country"
                                                                        >
                                                                            {getFieldDecorator("g_address_line_3", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter Address!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <Input placeholder="Address Line 3" />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback
                                                                                  label={"Postal Code"}
                                                                                >
                                                                                  {getFieldDecorator( 'g_zip_code', {
                                                                                    rules: [{ required: true, max: 10, message: 'Enter Your ZIP Code!' }],
                                                                                  })(
                                                                                    <Input placeholder={"ZIP Code"} maxLength={10} />
                                                                                  )}
                                                                                </FormItem>
                                                                              </Col>
                                                                </span>
                                                            )}
                                                            {this.state.yoursCountry == "616" ||
                                                                (this.state.yoursCountry == "" && (
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="ZIP Code">
                                                                            {getFieldDecorator("g_zip_code", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        // pattern: this.state.ZipCodePattern ,
                                                                                        message: "Enter ZIP Code!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <InputMask
                                                                                    // mask="******" // (alpha/ numeric)
                                                                                    // mask="99999" // (numeric)
                                                                                    placeholderChar=""
                                                                                    className="ant-input"
                                                                                    render={(ref, props) => (
                                                                                        <Input placeholder="ZIP Code" />
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                ))}
                                                        </Row>
                                                        {this.state.yoursCountry == "616" ||
                                                            this.state.yoursCountry == "" ? (
                                                            <Row
                                                                gutter={24}
                                                                style={{
                                                                    marginLeft: "0px",
                                                                    marginRight: "0px",
                                                                }}
                                                            >
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="ZIP Code">
                                                                        {getFieldDecorator("g_zip_code", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    max: 5,
                                                                                    min: 5,
                                                                                    message: "Enter ZIP Code!",
                                                                                },
                                                                            ],
                                                                        })(
                                                                            <InputMask
                                                                                // mask="*** ***" // (alpha/ numeric)
                                                                                mask="99999" // (alpha/ numeric)
                                                                                placeholderChar=""
                                                                                className="ant-input"
                                                                                render={(ref, props) => (
                                                                                    <Input placeholder="ZIP Code" />
                                                                                )}
                                                                            />
                                                                        )}
                                                                    </FormItem>
                                                                </Col>
                                                            </Row>
                                                        ) : null}
                                                    </Row>
                                                </Card>
                                            </Col>
                                            {/* <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Shipping Information"
                                                >
                                                    <Row>
                                                        <Col>
                                                            <FormItem hasFeedback
                                                                label="Type of Delivery"
                                                            >
                                                                {getFieldDecorator('shipping', {
                                                                    rules: [{ required: true, message: 'Choose Shippping Address!' }],
                                                                })(
                                                                    <RadioGroup onChange={this.ChangeShippingAddress} value={this.state.shippingAddress}>
                                                                        <Radio value={1}>Email</Radio>
                                                                        <Radio value={2}>Home Mailing Address</Radio>
                                                                    </RadioGroup>
                                                                )}
                                                            </FormItem>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col> */}
                                            <Col className="card-margin" span={24}>
                                                <Card
                                                    className="centered"
                                                    title="Membership Transaction Fee"
                                                >
                                                    <Row>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div
                                                                className="Summary-title-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                Optional Transaction Fee &nbsp;
                                                                <Tooltip
                                                                    placement="bottom"
                                                                    title="Please consider covering the transaction fees for this membership purchase"
                                                                >
                                                                    <Icon type="info-circle-o" theme="twoTone" />
                                                                </Tooltip>
                                                            </div>
                                                            {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                                        </Col>

                                                        <Col
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={12}
                                                            xl={12}
                                                            className="right"
                                                        >
                                                            <div className="summary-label-txt">
                                                                <Switch
                                                                    checked={this.state.isPayTransactionFees}
                                                                    onChange={() => this.calculateFee()}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {/* <Row>
                                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <div
                                                                className="summary-label-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                Transaction Fees
                                                            </div>
                                                        </Col>
                                                        <Col
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={12}
                                                            xl={12}
                                                            className="right"
                                                        >
                                                            <div className="summary-label-txt">
                                                                $ {this.state.transactionFee}
                                                            </div>
                                                        </Col>
                                                    </Row> */}
                                                </Card>
                                            </Col>
                                        </Row>

                                        <div className="steps-action centered">
                                            <div>
                                                <Row>
                                                    <Col
                                                        className="xs-center sm-center"
                                                        xs={24}
                                                        sm={24}
                                                        md={12}
                                                        lg={12}
                                                        xl={12}
                                                    >
                                                        <FormItem>
                                                            <Button
                                                                type="primary"
                                                                className="back-btn"
                                                                id="backToSearch-btn"
                                                                onClick={() => {
                                                                    let total = (
                                                                        Math.round(
                                                                            (parseFloat(
                                                                                this.state.SelectedMembershipPrice
                                                                            ) +
                                                                                parseFloat(
                                                                                    this.state.shipping_handlingCharge
                                                                                )) *
                                                                            100
                                                                        ) / 100
                                                                    ).toFixed(2);
                                                                    this.setState({
                                                                        isPayTransactionFees: false,
                                                                        TotalAmount: total,
                                                                    });
                                                                    this.prev();
                                                                }}
                                                            >
                                                                Back to Search
                                                            </Button>
                                                        </FormItem>
                                                    </Col>
                                                    <Col
                                                        className="xs-center sm-center"
                                                        xs={24}
                                                        sm={24}
                                                        md={12}
                                                        lg={12}
                                                        xl={12}
                                                    >
                                                        {this.renderPaymentButton()}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            )
                            }

                            {this.state.current == 3 && this.renderPaymentSummary()}

                            {this.state.current == 4 && (
                                <div>
                                    <div className="centered steps-payment margin-top-30">
                                        <Row
                                            className="margin-top-30 payment-row"
                                            gutter={48}
                                            type="flex"
                                            justify="space-between"
                                            align="center"
                                        >
                                            <Col xs={24} sm={24} md={24} lg={16} className="payment-col">
                                                <Card
                                                    className="margin-top-30"
                                                    title="Payment Information"
                                                >
                                                    <Row>
                                                        <Col span={10}>
                                                            <div className="checkbox-card-icon-wrapper">
                                                                <Row>
                                                                    <Col span={10}>
                                                                        <div
                                                                            className="title-txt margin-top-10"
                                                                            style={{ fontSize: "16px" }}
                                                                        >
                                                                            Credit Card
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <img src="../credit-card.png" height={40} />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Spin
                                                        tip={`Please do not close the browser until the Receipt is displayed! \n  Redirecting in ${seconds} seconds...`}
                                                        style={{ whiteSpace: "break-spaces" }}
                                                        spinning={this.state.receipt_loading}
                                                    >
                                                        {this.renderIframe()}
                                                    </Spin>
                                                </Card>
                                            </Col>

                                            <Col xs={24} sm={24} md={24} lg={8} className="payment-col">
                                                <Card className="margin-top-30" title="Summary">
                                                    <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="center"
                                                    >
                                                        <Col span={12}>
                                                            <span
                                                                className="title-txt"
                                                                style={{ fontSize: "16px" }}
                                                            >
                                                                Eagle Info
                                                            </span>
                                                        </Col>
                                                        <Col span={12} className="right">
                                                            <span className="verified">
                                                                <Icon type="check-circle" /> Verified
                                                            </span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span
                                                                className="label-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                {this.state.firstname} {this.state.middlename} {this.state.lastname}
                                                            </span>
                                                        </Col>
                                                        <Col span={24}>
                                                            <span
                                                                className="label-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                {this.state.memberId}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="center"
                                                    >
                                                        <Col span={24}>
                                                            <span
                                                                className="title-txt"
                                                                style={{ fontSize: "16px" }}
                                                            >
                                                                Level
                                                            </span>
                                                        </Col>

                                                        <Col span={18}>
                                                            <span
                                                                className="label-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                            { `${this.state.SelectedMembershipName} (with New Eagle Discount)` }
                                                            </span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span
                                                                className="summary-price"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                $ {this.state.SelectedMembershipPrice}
                                                            </span>
                                                        </Col>

                                                        {this.state.PromocodeApplied && (
                                                            <Row
                                                                type="flex"
                                                                justify="space-between"
                                                                align="center"
                                                                style={{ width: "100%" }}
                                                            >
                                                                <Col span={18}>
                                                                    <span
                                                                        className="label-txt green-txt"
                                                                        style={{ fontSize: "14px" }}
                                                                    >
                                                                        <CheckCircleTwoTone twoToneColor="#52c41a" />
                                                                        {this.state.DiscountCode}
                                                                    </span>
                                                                </Col>
                                                                <Col span={6} className="right">
                                                                    <span
                                                                        className="summary-price green-txt"
                                                                        style={{ fontSize: "14px" }}
                                                                    >
                                                                        -$ {this.state.DiscountAmount}
                                                                    </span>
                                                                </Col>
                                                            </Row>
                                                        )}

                                                        {this.state.PromocodeApplied && (
                                                            <Row style={{ width: "100%" }}>
                                                                <Col span={18}>
                                                                    <div
                                                                        className="summary-label-txt"
                                                                        style={{ fontSize: "14px" }}
                                                                    >
                                                                        Membership Cost
                                                                    </div>
                                                                </Col>

                                                                <Col span={6} className="right">
                                                                    <div className="summary-label-txt">
                                                                        $
                                                                        {parseFloat(
                                                                            parseFloat(
                                                                                this.state.SelectedMembershipPrice
                                                                            ) - parseFloat(this.state.DiscountAmount)
                                                                        ).toFixed(2)}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        )}
                                                        {this.state.PromocodeApplied && (
                                                            <Divider style={{ margin: "10px 0px" }} />
                                                        )}

                                                        <Col span={18}>
                                                            <span
                                                                className="label-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                {this.state.SelectedMembershipName} S/H
                                                            </span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span
                                                                className="summary-price"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                $ {this.state.shipping_handlingCharge}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    {this.state.isPayTransactionFees && (
                                                        <Row
                                                            type="flex"
                                                            justify="space-between"
                                                            align="center"
                                                        >
                                                            <Col span={18}>
                                                                <span
                                                                    className="label-txt"
                                                                    style={{ fontSize: "14px" }}
                                                                >
                                                                    Transaction Fees
                                                                </span>
                                                            </Col>
                                                            <Col span={6} className="right">
                                                                <span
                                                                    className="summary-price"
                                                                    style={{ fontSize: "14px" }}
                                                                >
                                                                    $ {this.state.transactionFee}
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {/* {this.state.PromocodeApplied && <Row type="flex" justify="space-between" align="center">
                                                        <Col span={18}>
                                                            <span className="label-txt green-txt" style={{ fontSize: '14px' }} ><CheckCircleTwoTone twoToneColor="#52c41a" /> {this.state.DiscountCode}</span>
                                                        </Col>
                                                        <Col span={6} className="right">
                                                            <span className="summary-price green-txt" style={{ fontSize: '14px' }}>-$ {this.state.DiscountAmount}</span>
                                                        </Col>
                                                    </Row>} */}
                                                    <hr />
                                                    <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="center"
                                                    >
                                                        <Col span={12}>
                                                            <span
                                                                className="title-txt"
                                                                style={{ fontSize: "16px" }}
                                                            >
                                                                Total
                                                            </span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <span
                                                                className="price-txt"
                                                                style={{ fontSize: "14px" }}
                                                            >
                                                                ${this.state.TotalAmount}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col
                                                className="xs-center sm-center"
                                                xs={24}
                                                sm={24}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                            >
                                                <div className="steps-action centered">
                                                    <div
                                                        className="text-result pointer"
                                                        style={{ marginTop: "55px", marginBottom: "55px" }}
                                                        onClick={() => {
                                                            // let total = (Math.round((parseFloat(this.state.SelectedMembershipPrice) + parseFloat(this.state.shipping_handlingCharge)) * 100) / 100).toFixed(2);
                                                            // this.setState({
                                                            //     ShowPaymentSummary: true,
                                                            //     isPayTransactionFees: false,
                                                            //     TotalAmount: total
                                                            // })
                                                            this.prev();
                                                        }}
                                                    >
                                                        <i className="fa fa-lg fa-long-arrow-left margin-right-5"></i>
                                                        Back to Eagle Summary
                                                    </div>
                                                </div>
                                                {/* <Button type="primary" className='back-btn' onClick={() => this.prev()}>Back to Step 2</Button> */}
                                            </Col>
                                        </Row>
                                    </div>
                                    {this.renderReceiptpage()}
                                </div>
                            )}
                            {this.state.current == 5 && (
                                <div>
                                    <div className="centered steps-receipt">
                                        <Row gutter={48} type="flex" className='receipt-row'>
                                            <Col
                                                xs={24}
                                                sm={24}
                                                md={8}
                                                lg={8}
                                                className="margin-top-30 receipt-col"
                                            >
                                                <Card className="">
                                                    <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="center"
                                                    >
                                                        <Col span={24}>
                                                            <span className="title-txt">Summary</span>
                                                        </Col>
                                                        <Col span={24} className="summary-block">
                                                            <span className="label-high-txt">Name</span>
                                                            <span className="label-txt">
                                                                {this.state.firstname} {this.state.middlename} {this.state.lastname}
                                                            </span>
                                                        </Col>
                                                        <Col span={24} className="summary-block">
                                                            <span className="label-high-txt">Date</span>
                                                            <span className="label-txt">
                                                                {moment().format("MM/DD/YYYY")}
                                                            </span>
                                                        </Col>
                                                        <Col span={24} className="summary-block">
                                                            <span className="label-high-txt">Address</span>
                                                            <span className="label-txt">
                                                                {this.state.address1 && (<React.Fragment>{this.state.address1}<br /></React.Fragment>)}
                                                                {this.state.address2 && (<React.Fragment>{this.state.address2}<br /></React.Fragment>)}
                                                                {this.state.address3 && (<React.Fragment>{this.state.address3}<br /></React.Fragment>)}
                                                                {this.state.city && this.state.userDetails.stateName && (<React.Fragment>{this.state.city}, {this.state.userDetails.stateName}<br /></React.Fragment>)}
                                                                {this.state.zip && (<React.Fragment>{this.state.zip}<br /></React.Fragment>)}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                    <Row>
                                                        <Col span={24} className="summary-block">
                                                            <span className="label-txt">
                                                                <b>{this.state.SelectedMembershipName}</b>
                                                            </span>
                                                        </Col>
                                                        <Col span={12} className="">
                                                            <span className="title-txt">Total</span>
                                                        </Col>
                                                        <Col span={12} className="right">
                                                            <span className="summary-price">
                                                                <b>${this.state.TotalAmount}</b>
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col
                                                s={24}
                                                sm={24}
                                                md={14}
                                                lg={14}
                                                className="margin-top-30 receipt-col"
                                            >
                                                <Card
                                                    className="receipt-header"
                                                    title="National Eagle Scout Association"
                                                >
                                                    <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="center"
                                                    >
                                                        <Col span={24} className="right">
                                                            <img src="../NESA.png" className="receipt-logo" />
                                                        </Col>
                                                        <Col>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH1}</p>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH2}</p>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH3}</p>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH4}</p>

                                                            <p>
                                                            {GIFTED_PURCHASE.PARAGRAPH5}
                                                                <a href="mailto:NESA@scouting.org">
                                                                    NESA@scouting.org
                                                                </a>
                                                            </p>
                                                        </Col>
                                                        <Col span={24} className="right signature-block">
                                                            <span>Yours in Scouting</span>
                                                            <img
                                                                src='JohnStachniak_Signature.jpg'
                                                                className="director-logo"
                                                            />
                                                            <span>
                                                                <b>John Stachniak</b>
                                                            </span>
                                                            <span>
                                                                Director, National Eagle Scout Association
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Button
                                                    type="primary"
                                                    className="submit-btn"
                                                    onClick={() =>
                                                        window.location.assign("https://nesa.org/")
                                                    }
                                                >
                                                    GO HOME
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="steps-action centered">
                            {this.state.current == 0 && (
                                <div className="membership-bottom"></div>
                            )}
                            {this.state.current == 1 && (
                                <div className="membership-bottom"></div>
                            )}
                            {this.state.current == 2 && (
                                <div className="membership-bottom"></div>
                            )}
                        </div>
                    </div>
                </div>
                <NESAFooter />


                <Modal
                    className="multiple-r-modal"
                    title={false}
                    footer={false}
                    visible={this.state.showResultModal}
                    centered
                    onCancel={() => this.closeResult()}
                >
                    <Row type="flex" align="left">
                        <Col xs={24}>
                            <div>
                                <span className="modal-header">Multiple Records Found</span>
                                <span className="modal-desc">
                                    Multiple records were found, please select one.
                                </span>
                            </div>
                        </Col>
                    </Row>

                    {this.renderSearchResults()}

                    <Row type="flex" align="center" className="center">
                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <div className="step-container margin-top-20">
                                <Button
                                    type="primary"
                                    className="submit-btn"
                                    onClick={() => {
                                        // let BOR = this.state.selectedRecord.eagleBoardReviewDate
                                        // if (BOR != "" && BOR != null && BOR != undefined) {
                                        this.SelectEagle();
                                        // } else {
                                        //     this.show_no_identifying_information_PopUp()
                                        // }
                                    }}
                                >
                                    SELECT
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Modal>

                <Modal
                    className="No-records-Found-model"
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsFound}
                    centered
                    onCancel={() => this.close_NoResultsFound_Modal()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className="No-Results-Match-Pro">
                            Missing Information
                        </div>

                        {/* <div className='margin-bottom-20'> Whoops! We found the Scout but there wasn't any Eagle Scout information associated with them.  Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Eagle Scout council for further assistance.</div> */}

                        <div className="margin-bottom-20">

                            Whoops! it appears there is critical information regarding First
                            Name, Last Name or Date of Birth, missing from your Eagle Scout
                            record.
                        </div>
                        {/* <div style={{color: ' #cc0033', marginBottom: '10px'}}>
                            Firstname, Lastname, Date of Birth
                        </div>
                        <div> please contact your Eagle Scout council for further assistance.</div>
                        <div sty    '10px 20px', margin: '10px 0px', color: ' #cc0033'}}>
                            Missing or incomplete ID records in Akela (the master membership database)
                        </div> */}

                        {/* <div> Note: The missing information would identify the missing or incomplete information needed to complete a NESA application </div>  */}

                        <div>

                            Please contact your Eagle Scout council to update your Eagle
                            information.
                        </div>

                        <Row
                            type="flex"
                            style={{ justifyContent: "center", alignItems: "center" }}
                        >
                            <Col
                                className="xs-center sm-center"
                                xs={9}
                                sm={9}
                                md={7}
                                lg={7}
                                xl={7}
                            >
                                <div className="step-container margin-top-20">
                                    <Button
                                        type="primary"
                                        className="submit-btn"
                                        style={{ margin: 0, fontSize: "13px", width: "100%" }}
                                        onClick={() => {
                                            this.close_NoResultsFound_Modal();
                                        }}
                                        htmlType="submit"
                                    >
                                        CLOSE
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className="No-records-Found-model"
                    title={false}
                    footer={false}
                    visible={this.state.noIdentifyingInformation}
                    centered
                    onCancel={() => this.close_no_identifying_information_PopUp()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className="No-Results-Match-Pro">No Record Found!</div>

                        <div className="margin-bottom-20">
                            Whoops! We found the Scout, but there wasn’t any Eagle Scout
                            information associated with them.
                        </div>
                        <div>

                            Please confirm the Scout’s Eagle Scout MemberID and try again.
                            Alternatively, you can reach out to your local council for further
                            assistance.
                        </div>

                        <Row
                            type="flex"
                            style={{ justifyContent: "center", alignItems: "center" }}
                        >
                            <Col
                                className="xs-center sm-center"
                                xs={9}
                                sm={9}
                                md={7}
                                lg={7}
                                xl={7}
                            >
                                <div className="step-container margin-top-20">
                                    <Button
                                        type="primary"
                                        className="submit-btn"
                                        style={{ margin: 0, fontSize: "13px", width: "100%" }}
                                        onClick={() => {
                                            this.close_no_identifying_information_PopUp();
                                        }}
                                        htmlType="submit"
                                    >
                                        CLOSE
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>

                {this.state.isShow_MissingFieldsPopup && <Modal
                    className="multiple-r-modal"
                    title={false}
                    footer={false}
                    visible={this.state.isShow_MissingFieldsPopup}
                    centered
                    onCancel={() => this.closeMissingFieldsPopup()}
                    style={{ width: '500px' }}
                >

                    <Row type="flex" align="left">
                        <Col xs={24}>
                            <div >
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <img src={warningAlert} width="25px" height="25px" style={{ marginRight: '10px' }} />
                                    <span className="modal-header">Missing Information</span>
                                </div>
                                <div className="modal-desc" style={{ margin: '10px 0px' }}>
                                    It appear required information is missing "Scout's Email" {/* [list missing field here]. */} Please update that information in order to complete your
                                    application process.
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Form onSubmit={this.handleSubmit_MissingField} className="Scout-email-form alumni-ui">
                        {/* <Col className="card-margin search-alumni" span={24}> */}
                        {/* <Card
                                className="centered"
                                title="Scout's Missing Information"
                            > */}
                        <Row type="flex" align="center" className="center" style={{ textAlign: 'left' }} >
                            {/* <div className="center"> */}

                            <Col xs={24} sm={24} md={12} lg={12} xl={8}  >
                                <FormItem hasFeedback label="Scout’s Email" style={{ width: '100%' }}>
                                    {getFieldDecorator("email", {
                                        rules: [
                                            {
                                                required: true,
                                                type: "email",
                                                message: "Enter valid email address!",
                                            },
                                        ],
                                    })(<Input placeholder="Email" />)}
                                </FormItem>
                            </Col>
                            {/* </div> */}
                        </Row>



                        <Row type="flex" align="center" justify="end">
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <div className="step-container " style={{ margin: '0px' }}>
                                    <FormItem >
                                        <Button
                                            type="primary"
                                            className="submit-btn"
                                            htmlType="submit"
                                            style={{ margin: '0px' }}
                                        //   onClick={() => {}}
                                        >

                                            NEXT
                                        </Button>
                                    </FormItem>
                                </div>
                            </Col>
                        </Row>
                        {/* </Card> */}
                        {/* </Col> */}
                    </Form>


                </Modal>
                }

                <Modal
                    centered
                    className='ExistingLifeTimePlanModal'
                    visible={this.state.existingLifePlan}
                    closable={false}
                    footer={
                        <Button key="submit" type="primary" className='RedirectExistingLifePlan'
                            onClick={this.closeExistingLifePlanModal}>
                            Close
                        </Button>
                    }
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>

                        <div className='Existing-Lifeplan-Info'>
                            <span className='modal-desc'>You already have an existing NESA Lifetime plan. </span>
                        </div>
                    </div>
                </Modal>


                <Modal
                    centered
                    className="IneligibleNESAModal"
                    closable={false}
                    visible={this.state.isIneligible}
                    footer={
                        <Button
                            key="back"
                            className="CloseIneligibleNESAModal"
                            onClick={this.closeIneligibleNESAModal}
                        >
                            Close
                        </Button>
                    }
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>

                        <div className="No-Results-Match-Pro">Whoops!</div>

                        <div className="margin-bottom-20">
                            It appears the person you're attempting to request NESA membership
                            is not eligible for this program.
                        </div>
                        <div>
                            Please contact the individual directly and if questions arise,
                            have them contact their local council.
                        </div>
                    </div>
                </Modal>
                
                {this.state.doesShowNewMemberGreetings && <NewEagleGreetingsModal 
                doesShowNewMemberGreetingsProps={this.state.doesShowNewMemberGreetings} 
                closeNewMemberGreetingsModalHandler={this.closeNewMemberGreetingsModal} 
                />}

                <CustomPopupModal
                    doesShowPopup={this.state.isDeceasedPerson}
                    closePopup={this.closeDeceasedPersonPopup}
                    popupTitle={"Invalid Membership Purchase"}
                    popupPrimaryContent={deceasedPopup_primaryConent}
                    popupSecondaryContent={deceasedPopup_secondaryConent}
                />

                {this.state.showLookupError && <CustomPopupModal
                    doesShowPopup={this.state.showLookupError}
                    closePopup={this.retryToLoadFailedLookups}
                    popupTitle={"Internal Server Error"}
                    btnText={"RETRY"}
                    popupPrimaryContent={`${failedToLoadLookup_Popup_primaryConent} "${this.state.failedLookups.join(', ')}" lookup data `}
                    popupSecondaryContent={failedToLoadLookup_secondaryConent}
                />
                }


                <FullPageSpinner spinning={this.state.pageLoader} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        initloading: state.chasepaymentreducer.loading,
        initTransaction: state.chasepaymentreducer.initTransaction,
        profile_loading: state.profilereducer.loading,
        profile_info: state.profilereducer.profileinfo,
        productprice: state.productpricereducer.productprice,
        productprice_loading: state.productpricereducer.loading,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        registration_loading: state.giftmembershipreducer.loading,
        registered: state.giftmembershipreducer.response,
        allstates: state.allstatesreducer.states,
        countries: state.countriesreducer.countries,
        phonecode: state.phonecountrycodereducer.code,
        loading: state.giftmembershipreducer.loading,
        response: state.giftmembershipreducer.response,
        regstatus: state.regstatusreducer.status,
        searching: state.eagleSearchReducer.searching,
        searchedEagle: state.eagleSearchReducer.eagle,
        alumnieagleinfo: state.alumnieagleinforeducer.eagleinfo,
        alumnieagleinfo_loading: state.alumnieagleinforeducer.loading,
        applingPromocode: state.promocodereducer.loading,
        PromocodeAdded: state.promocodereducer.response,
        promoCode: state.promocodereducer.promoCode,
        PromocodeRemoved: state.promocodereducer.removedPromoAmount,
        PromocodeError: state.promocodereducer.error,
        creatingPayments: state.PaymentsCreateReducer.loading,
        createdPayments: state.PaymentsCreateReducer.response,
        nesa_reg: state.nesaregistrationreducer.reg,
        shoppingCartList: state.shoppingCartReducer.response,

        ethnicitiesError: state.ethnicitiesreducer.error,
        productpriceError: state.productpricereducer.error,
        nesa_levelsError: state.nesalevelsreducer.error,
        allstatesError: state.allstatesreducer.error,
        countriesError: state.countriesreducer.error,
        phonecodeError: state.phonecountrycodereducer.error, 
        regError: state.regstatusreducer.regError,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) };
}

const GiftMembership = Form.create()(GiftMembershipForm);

export default connect(mapStateToProps, mapDispatchToProps)(GiftMembership); 


// WEBPACK FOOTER //
// ./src/components/Membership/GiftMembership.js